export default {
  pageTitle: 'Wohnmobil verkaufen: Zum Höchstgebot - online und kostenlos',
  title: 'Verkaufen Sie {0} online zum Höchstgebot',
  title_full: 'Wohnmobil verkaufen: Bequem <span class="primary--text">online</span> zum Höchstgebot',
  hero_subtitle: 'Mühelos Ankaufsangebote von über 250 Fachhändlern einholen. Einfach online verkaufen, falls Ihnen das höchste Gebot zusagt.',
  description:
    'Profitieren vom Bietergefecht beim Wohnmobil verkaufen. Über 200 seriöse Händler bieten online auf Ihr gebrauchtes Wohnmobil. 100% kostenlos für Verkäufer!',
  merchant_area: 'Händlerbereich',
  signin: 'Anmelden',
  my: 'Mein',
  continue: 'Weiter',
  continue_no_cost: 'Kostenfrei fortfahren',
  submit_anr_step_6: 'Angebote neu einholen',
  'submit_anr_step_6.success': 'Angebotseinholung gestartet, wir drücken Ihnen die Daumen!',
  register_no_cost: 'Kostenfrei registrieren',
  continue_to_last_step: 'zum letzten Schritt',
  back: 'Zurück',
  messages: 'Nachrichten',
  actions: 'Nachrichten',
  loading: 'Laden ...',
  done: 'Abgelaufen!',
  close: 'Schließen',
  close_and_continue: 'Fortsetzen',
  subject: 'Betreff',
  submit: 'Absenden',
  submit_for_review: 'Kostenloses Angebot einholen',
  submit_for_review_merchant: 'Inserat absenden',

  skip: 'Überspringen',
  delete: 'Löschen',
  logging_into: 'Einloggen auf',
  verifying_email: 'E-Mail Adresse wird verifiziert',
  verifying_phone: 'Mobilfunknummer verifizieren',
  'verifying_phone.bypass_title': 'Mobilfunknummer verifizieren',
  'verifying_phone.bypass_text': 'Es tut uns leid, aber wir können momentan Ihre Mobilfunknummer nicht per SMS Code verifizieren. Bitte klicken Sie auf die Schaltfläche unten, um ohne Verifizierung fortzufahren. Wir entschuldigen uns für die Unannehmlichkeiten und arbeiten an einer Lösung.',
  'verifying_phone.bypass_cta': 'Fortfahren',
  'verifying_phone.bypass_failed': 'Es ist ein Fehler aufgetreten. Bitte versuchen Sie es später erneut.',
  verified_phone: 'Telefonnummer verifiziert',
  'landing.onboarding.phone_number_already_in_use': 'Diese Mobilfunknummer wird bereits von einem anderen Konto verwendet. Bitte verwenden Sie eine andere Mobilfunknummer oder melden Sie sich mit Ihrem bestehenden Konto an.',
  'landing.onboarding.phone_number_is_not_a_valid_mobile_number': 'Die eingegebene Mobilfunknummer ist ungültig. Bitte geben Sie eine gültige Mobilfunknummer ein.',
  'verifying_phone.link_to_login': 'Zum Login',
  edit_phone: 'Ändern',
  wrong_number: 'Nummer falsch',
  send_again: 'Erneut senden',
  show: 'anzeigen',
  important_e: 'Wichtige',
  mandatory_fields: 'Pflichtfelder',
  mandatory_fields_done: 'Erledigt',
  mandatory_fields_to_do: 'Ausstehend',
  From: 'Von',
  To: 'Bis',
  Any: 'Beliebig',
  sign_in_footnote: 'Es gelten die Allgemeinen Geschäftsbedingungen. Informationen zur Verarbeitung aller Daten werden in unserer {0} erläutert',
  terms_and_conditions: 'Datenschutzerklärung',
  forgot_password: 'Passwort vergessen?',
  password_reset_email_sent: 'E-Mail zum Zurücksetzen des Passworts wurde gesendet',

  wrong_password_personal_data_funnel_20: 'Sie haben sich bereits registriert. Das von Ihnen vergebene Passwort stimmt nicht mit dem eingegeben überein. Bitte versuchen Sie es erneut.',

  of_which_are_set: 'davon gesetzt',
  optional_fields: 'Keine Pflichtfelder',
  optional_fields_fill_out_if_known: 'Keine Pflichtfelder, wenn bekannt bitte angeben',
  yes: 'ja',
  Yes: 'Ja',
  na: 'k.A.',
  no: 'nein',
  No: 'Nein',
  back_to: 'Zurück zu',
  saved: 'Gespeichert',
  all: 'Alle',
  edit: 'bearbeiten',
  Edit: 'Bearbeiten',
  Delete: 'Löschen',
  offers: 'Angebote',
  germany: 'Deutschland',
  country: 'Land',

  welcome: 'Willkommen',
  login: 'Anmelden',
  login_or_register: 'Anmelden oder Registrieren',
  register: 'Registrieren',
  home: 'Startseite',
  faq: 'Häufige Fragen',
  merchant: 'Händler',
  about: 'Über uns',
  jobs: 'Jobs',
  known_from: 'Bekannt aus',
  back_to_search_results: 'Zurück zu den Suchergebnissen',
  x_results_in_search: 'Wohnmobil kaufen: {0} Ergebnisse',
  do_you_have_more_questions: 'Haben Sie weitere Fragen zum Fahrzeug?',
  'messages.answer.title': 'Ihre Antwort',
  'messages.question.title': 'Frage an Fahrzeughalter',

  send_another_question_when_seller_answered: 'Sobald der Verkäufer ihre letzte Frage beantwortet hat, haben Sie die Möglichkeit, eine weitere Nachricht zu senden.',
  you_can_ask_the_seller_a_question: 'Sie haben die Möglichkeit, dem Verkäufer eine Nachricht zu senden.',
  ask_a_question: 'Frage an den Fahrzeughalter stellen',
  show_all_information: 'Alle Informationen anzeigen',
  hide_information: 'Informationen einklappen',
  product_location: 'Standort',
  mileage: 'Kilometerstand',
  estimated_mileage: 'geschätzter Kilometerstand',
  first_registration: 'Erstzulassung',
  zipcode: 'PLZ',
  motorhomes: 'Wohnmobile',
  trailers: 'Wohnwagen',
  remove_all: 'Alle entfernen',
  on: 'An',
  off: 'Aus',
  this: 'Dies',

  'auction.status.editing': 'In Bearbeitung',
  'auction.status.under_review': 'In Prüfung',
  'auction.status.endet': 'Beendet',
  'auction.status.failed_na': 'Nicht mehr verfügbar',

  'auction.status.published': 'Beginnt in Kürze',
  'auction.status.hotbidding': 'Hotbid-Phase',
  'auction.status.running': 'Aktiv',
  'auction.status.sold': 'Verkauft',
  'auction.status.acpt_late_offer': 'Kaufchance',
  'auction.status.recd_late_offer': 'Kaufchance: ausstehend',
  'auction.status.recd_late_offer_owner': 'Kaufangebot erhalten',
  'auction.status.renegotiation': 'Nachverhandlung',
  'auction.status.anr_offer_above_targetprice': 'Vorbehalt',
  'auction.status.inactive': 'Inaktiv',
  'auction.status.declined_late_offer': 'Kaufchance: abgelehnt',

  'auction.published_without_review': 'Hinweis von caravanmarkt24: Alle Inseratsdaten basieren ausschließlich auf Angaben des Verkäufers. Angaben können fehlerhaft sein.',

  'customer.context.late_offer_declined': 'Kaufchance: abgelehnt',
  'customer.context.late_offer_pending': 'Kaufangebot gesendet',

  'customer.context.offer_declined': 'Gebot: abgelehnt',

  'customer.context.bidding_agent_disabled_without_startprice': 'Ein Bietagent kann nur gespeichert werden, nachdem ein Startgebot abgegeben wurde.',
  'customer.context.holding_highest_bid': 'Sie sind Höchstbietender',
  'customer.context.overbid': 'Sie wurden überboten',
  'customer.context.first_bid_too_low': 'Ihr Gebot ist zu niedrig',

  'customer.context.first_bidding_agent_limit_too_low': 'Das Limit für Ihren Bietagenten ist zu niedrig',

  'customer.context.late_offer_too_low': 'Gebot zu niedrig, erneut bieten',

  product_profile: 'Fahrzeugprofil',
  trailer_profile: 'Wohnwagenprofil',

  product_profile_technical: 'Technische Daten',
  'product_profile_technical.mobile': 'Eckdaten',

  trailer_profile_technical: 'Technische Daten',
  product_profile_history: 'Historie und Pflegezustand',
  'product_profile_history.mobile': 'Pflegezustand',
  trailer_profile_history: 'Historie und Pflegezustand ',
  product_documents: 'Dokumente',
  product_documents_extern: 'Externen Zustandsbericht herunterladen',

  product_equipment: 'Ausstattung',
  product_equipment_car: 'Basisfahrzeug',
  product_equipment_womo: 'Wohnbereich',
  product_more_information: 'Weitere Details',

  trailer_equipment: 'Ausstattung',
  trailer_equipment_car: 'Basisanhänger',
  trailer_equipment_living: 'Wohnbereich',

  product_description: 'Beschreibung',
  product_description_general: 'Allgemeine Beschreibung',
  product_description_defects: 'Beschreibung von bekannten Mängeln',
  product_description_defects_1: 'Bekannte Mängel',
  product_description_defects_2: 'Bilder von Mängeln hochladen',
  product_description_defects_title: 'Mängel',

  damages: 'Schäden',
  trailer_damages: 'Schäden',
  known_defects: 'Bekannte Mängel',
  no_defects_known: 'Keine erwähnenswerten Mängel bekannt',

  'editable.image.catalog_main_image': 'Titelbild',
  'editable.image.catalog_set_as_main_image': 'Als Titelbild setzen',
  'editable.image.edit_image': 'Bild bearbeiten',
  'editable.image.delete_image': 'Bild löschen',
  'editable.image.confirm_delete': 'Möchten Sie dieses Bild wirklich löschen? Diese Aktion kann nicht rückgängig gemacht werden.',

  product_images: 'Bilder',
  product_image: 'Bild',
  product_images_and_documents: 'Bilder und Dokumente',
  product_images_car: 'Fahrzeugbilder',
  product_images_registration:
    'Zulassungsbescheinigung Teil I (Fahrzeugschein)',
  product_images_document:
    'Offizielles Dokument hochladen',
  product_images_damages: 'Schadensbilder',

  more_information_title: 'Verkaufschance erhöhen',
  more_information_subtitle: 'Durch die zeitnahe Bereitstellung weiterer Daten und Informationen erhöhen Sie die Chance auf den Verkauf Ihres Fahrzeugs. Je schneller Sie die Informationen übermitteln, desto...',

  more_images_title: 'Bilder',
  more_images_warning: 'Sie haben zu wenig Fahrzeugbilder hochgeladen. Bitte übermitteln Sie weitere aussagekräftige Bilder. Je mehr Bilder Sie hochladen, desto besser.',

  more_images_checked_bullets_1: 'Mindestens 5 Bilder von außen, idealerweise von allen Seiten',
  more_images_checked_bullets_2: 'Mindestens 5 Bilder von innen, insbesondere Fahrerhaus, Betten, Bad, Dinette, ggf. weitere Besonderheiten',
  more_images_cross_bullets_1: 'Keine Bilder von Dokumenten hochladen, die persönliche Daten zeigen',
  more_images_cross_bullets_2: ' Keine Bilder hochladen, die explizit Schäden zeigen. Falls Sie nachträglich Bilder zu Schäden übermitteln möchten, senden Sie diese bitte per E-Mail an {0}',

  more_images_success: 'Vielen Dank! Ihre Bilder wurden erfolgreich hochgeladen und Ihrem Inserat hinzugefügt.',

  more_information_success: 'Vielen Dank, Ihre Angaben wurden Ihrem Inserat hinzugefügt!',

  generic_error: 'Es ist ein Fehler aufgetreten. Bitte versuchen Sie es später erneut.',

  auction: 'Auktion',

  selling_price: 'Verkaufspreis',

  min_selling_price: 'Preisvorstellung',

  step_6_title: 'Verkaufskonditionen',
  set_min_selling_price: 'Verkaufskonditionen festlegen',
  min_selling_price_anr: 'Preisvorstellung',

  auction_and_price: 'Auktion und Preis',
  auction_general: 'Details zur Auktion',

  'product.damage_on': 'Schaden an',

  'product.description_translation_switch':
    'Beschreibung im Original (deutsch)',
  'product.description_translation_notification':
    'Die Beschreibung wurde automatisch aus dem Deutschen übersetzt. Um die Originalbeschreibung zu sehen, klicken Sie auf den Button mit der Aufschrift "DE".',

  'product.place_bid_x': 'Direktgebot von {0} abgeben',
  'product.place_initial_bid_x': 'Startgebot von {0} abgeben',
  'product.buy_now_for_': 'Sofort kaufen für',
  'product.confirm_buy_now': 'Sofortkauf bestätigen',
  'product.place_next_bid': 'Gebot {0} abgeben',
  'product.confirm_bid': 'Gebot bestätigen',
  'product.confirm_bid_x': 'Gebot {0} bestätigen',
  'product.obligatory_bid': 'Das Gebot ist 48 Stunden lang verbindlich oder bis der Verkäufer entscheidet, es abzulehnen',

  'product.set_bid_simple': 'Gebot einstellen',
  'product.set_initial_bid': 'Startgebot einstellen',
  'product.set_bid': 'Direktgebot einstellen',
  'product.set_bidding_agent_value': 'Neues Limit für Ihren Bietagenten',

  'product.set_bidding_agent_btn': 'Neues Limit von {0} speichern',
  'product.set_bidding_agent_btn_init': 'Bietagenten speichern',
  'product.show_bidding_agent': 'Bietagenten anzeigen',
  'product.hide_bidding_agent': 'Bietagenten ausblenden',
  'product.repaired_damage_details': 'Behobener Unfallschaden',
  'product.damage_details': 'Bestehender Unfallschaden',
  'product.repaired_water_damage_details': 'Behobener Wasserschaden',
  'product.water_damage_details': 'Bestehender Wasserschaden',
  'product.repaired_hail_damage_details': 'Behobener Hagelschaden',
  'product.hail_damage_details': 'Bestehender Hagelschaden',

  'product.more_details.damage_repaired_parts': 'Betroffene Fahrzeugteile',
  'product.more_details.damage_not_repaired_parts': 'Betroffene Fahrzeugteile',

  'product.more_details.damage_not_repaired_usable': 'Fahrbereit?',
  'product.more_details.damage_not_repaired_costs': 'Voraussichtliche Reparaturkosten (netto)',
  'product.more_details.damage_not_repaired_insurance': 'Wer erhält Versicherungsleistung?',

  'product.more_details.water_damage_not_repaired_parts': 'Betroffene Bereiche',
  'product.more_details.hail_damage_not_repaired_parts': 'Betroffene Bereiche',
  'product.more_details.water_damage_repaired_parts': 'Betroffene Bereiche',

  'product.more_details.hail_damage_repaired_parts': 'Betroffene Bereiche',

  'product.more_details.damage_repaired_professionally': 'Fachgerecht repariert?',
  'product.more_details.hail_damage_not_repaired_costs': 'Voraussichtliche Reparaturkosten (netto)',
  'product.more_details.hail_damage_repaired_costs': 'Reparaturkosten (netto)',

  'product.more_details.hail_damage_insurance': 'Wer erhält Versicherungsleistung?',

  'product.more_details.water_damage_repaired_professionally': 'Fachgerecht instandgesetzt?',
  'product.more_details.hail_damage_repaired_professionally': 'Fachgerecht repariert?',
  'product.more_details.water_damage_repaired_how': 'Die betroffenen Teile wurden...',

  'product.more_details.water_damage_repaired_quality': 'Wasserrückstände?',
  'product.more_details.damage_repaired_invoice': 'Rechnung vorhanden?',

  'product.more_details.expired.message': 'Die Bearbeitungszeit ist leider abgelaufen. Ihre bisherigen Angaben wurden nicht übermittelt!',

  'product.answer': 'Antwort: {0}',

  pricing: 'Preise',

  'valuation.intro.subtext': 'Felder mit Sternchen sind Pflichtfelder. Je mehr Felder Sie befüllen, desto genauer ist die Bewertung.',

  minimum_selling_price: 'Preisvorstellung',
  hammer_price: 'Zuschlagspreis',
  start_price: 'Startpreis',
  hidden: 'Verdeckt',
  first_initial_bid: 'Startgebot',
  sold_price: 'Kaufpreis',
  maximum_high_bid_reached: 'Maximales Höchstgebot erreicht',
  current_highest_bid: 'Aktuelles Höchstgebot',
  current_price: 'Aktueller Preis',
  no_bid_yet: 'bisher kein Gebot',
  last_bid: 'Letztes Gebot',
  amount_of_mandatory_fields_set: 'Pflichtfelder ausgefüllt zu',

  my_ad: 'Mein Inserat',
  open_my_ads: 'Inserat aufrufen',
  continue_editing: 'Weiter bearbeiten',
  finalized_ad: 'Inserat fertigstellen',
  administer_ad: 'Inserat verwalten',
  enrich_editing: 'Inseratsqualität verbessern',
  to_renegotiation: 'Zur Nachverhandlung',
  to_watchlist: 'Zur Merkliste',

  to_renegotiation_message_to_seller: 'Zum Nachrichtenverlauf',
  to_late_offer_pending: 'Ihre Kaufchance: ausstehend',
  to_my_purchases: 'Meine Käufe ansehen',

  goto_resubmit: 'Neues Bieterverfahren',
  resubmit_button_text: 'Kaufangebote neu einholen',

  'resubmit.popup.editing.title': 'Vorab Preis anpassen',

  'resubmit.cta': 'Angebote neu einholen',
  'resubmit.edit.cta': 'Inserat überarbeiten',
  'resubmit.popup.step3.title': 'Angebotseinholung läuft!',
  'resubmit.popup.step3.text1': 'Ihre neue Preisvorstellung von <strong>{0}</strong> wurde übernommen. Sind vor dem Start noch <strong>Inseratsänderungen</strong> erforderlich (z.B. Km-Stand, Zustand, Bilder etc.)?',

  'resubmit.popup.title': 'Kurzer Check vor dem Neustart: Sind alle Inseratsangaben noch korrekt?',
  'resubmit.popup.text': 'Haben sich technische Details oder der Zustand Ihres Fahrzeugs seit dem letzten Mal geändert?',

  'resubmit.edit.popup.pretext': 'Bevor Sie Ihr Inserat überarbeiten können, um neue Angebote einzuholen, ist eine Preissenkung erforderlich.',

  'resubmit.edit.popup.ad_analysis': 'Ihr Fahrzeug hat leider bisher noch keinen Käufer gefunden. Häufig liegt dies an einer unrealistischen, nicht marktgerechten Preisvorstellung. Setzen Sie jetzt mit einer kleinen Preissenkung den entscheidenden Verkaufsimpuls.',
  'resubmit.popup.ad_analysis': 'Ihr Fahrzeug hat leider bisher noch keinen Käufer gefunden. Setzen Sie jetzt mit einer <strong>kleinen Preissenkung</strong> den entscheidenden Verkaufsimpuls.',
  'resubmit.popup.ad_analysis.last_bid_higher_than_target_price': 'Wir haben Ihr Inserat und die aktuelle Marktsituation analysiert. Da Ihr Fahrzeug bisher keinen Käufer gefunden hat, empfehlen wir Ihnen, durch eine geringfügige Preissenkung den <strong>entscheidenden Verkaufsimpuls</strong> zu setzen.',

  'resubmit.popup.step2.title': 'Exklusiv anbieten – maximal profitieren',
  'resubmit.popup.step2.text': 'Für das bestmögliche Kaufangebot benötigen wir <strong>Planungssicherheit</strong>. Kaufinteressenten bieten <strong>deutlich höher</strong> auf Inserate mit <strong>klar erkennbarer</strong> Verkaufsabsicht.',

  'resubmit.popup.step2.listing.1': 'Schnelle Angebotseinholung',
  'resubmit.popup.step2.listing.2': 'Chance auf höchsten Preis',
  'resubmit.popup.step2.listing.3': 'Bindungsfrist erlischt automatisch',

  'resubmit.popup.step2.confirmation.text': '„Klingt fair! Ich verkaufe verbindlich für <strong>{0}</strong>, falls ich innerhalb von <strong>{1} Stunden</strong> ein entsprechendes Angebot erhalte.“',

  'resubmit.popup.step2.no_risk': '<strong>Kein Risiko</strong>: Verpflichtung erlischt nach {0}h',

  'resubmit.popup.step2.confirmation': 'Bestätigen und profitieren',

  'resubmit.popup.old_target_price': 'Ihre bisherige Preisvorstellung: {0}',

  'resubmit.popup.higher_demand': 'Höhere Nachfrage',
  'resubmit.popup.moderate_price_adjustment': 'Durch eine moderate Preisanpassung steigt die Anzahl der Kaufinteressenten deutlich an.',
  'resubmit.popup.quicker_sell': 'Schneller Abschluss',
  'resubmit.popup.fair_price_advantage': 'Ein marktgerechter Preis führt erfahrungsgemäß zum Verkaufserfolg innerhalb kürzester Zeit.',
  'resubmit.popup.adjust_price': 'Wählen Sie nachfolgend eine Preisanpassung, um Ihr Inserat neu zu veröffentlichen:',

  'resubmit.popup.adjust_price.target_price_max_last_bid': 'Bitte nehmen Sie eine moderate Preisanpassung vor, um Ihr Inserat neu zu veröffentlichen.',

  'resubmit.popup.your_price': 'Eigene Preisvorstellung',
  'resubmit.popup.absolute_free': '100% Kostenfrei',
  'resubmit.popup.your_price.last_bid_higher_than_target_price': 'Neue Preisvorstellung',
  'resubmit.popup.max': 'max. {0}',
  'resubmit.popup.submit_changes': 'Inseratsänderungen vornehmen',
  'resubmit.popup.confirm_price_and_next': 'Preis bestätigen & weiter',
  'resubmit.popup.go_to_ad_intake.step2': 'Inserat jetzt überarbeiten',
  'resubmit.popup.go_to_ad_intake.step3': 'Inserat überarbeiten',
  'resubmit.popup.step4.text': 'Wir drücken Ihnen die Daumen! Wir melden uns spätestens zum Ende der Angebotseinholung per E-Mail mit dem Ergebnis.',

  'resubmit.popup.step4.text.box': 'Die Angebotseinholung endet in {0} Std. und {1} Min. Ihre Bindungsfrist läuft entsprechend am <strong>{2} um {3} Uhr </strong> ab.',

  'resubmit.popup.go_next': 'Zum nächsten Schritt',
  'resubmit.popup.go_to_last_step': 'Akzeptieren und fortfahren',
  'resubmit.popup.link_to_my_ads': 'Zurück zur Übersicht',
  'resubmit.popup.submit_without_changes': 'Angebote jetzt einholen',
  'resubmit.popup.edit_if_you_want_to': 'Sie können bei Bedarf im nächsten Schritt Ihr Inserat noch überarbeiten.',
  'resubmit.popup.warning': 'Bitte wählen Sie eine gültige Preisvorstellung aus.',
  'resubmit.popup.warning.custom': 'Ihre Preisvorstellung darf nicht höher als der Mindestabschlag von 2% ({0}) sein.',

  'resubmit.popup.warning.not_confirmed': 'Bitte stimmen Sie der Exklusivitätsvereinbarung zu.',

  'resubmit.popup.subtext': 'Sind vor dem Start Änderungen an Ihrem Inserat erforderlich?',
  'resubmit.popup.cancel.button': 'Abbrechen',
  'resubmit.popup.back_to_ad_intake': 'Inserat bearbeiten',
  'resubmit.popup.submit.button': 'Jetzt Angebote einholen',

  'reduce.price.popup.title': 'Preisvorstellung senken?',
  'reduce.price.popup.text': 'Ihre Preisvorstellung lag zuletzt bei {0}. Möchten Sie die Preisvorstellung senken, um die Chance auf den Verkauf zu erhöhen? Kaufinteressenten sehen Ihre Preisvorstellung. Eine unrealistische Preiserwartung schreckt leider Kaufinteressenten ab.',
  'reduce.price.popup.button.yes': 'Preisvorstellung senken',
  'reduce.price.popup.button.no': 'Preisvorstellung beibehalten',
  'reduce.price.popup.button.no.success': 'Angebotseinholung gestartet, wir drücken Ihnen die Daumen!',
  'reduce.price.reduce.popup.button.submit': 'Jetzt starten',

  delete_ad: 'Inserat löschen',
  edit_ad: 'Inserat bearbeiten',
  'edit_ad.title': 'Inserat aktualisieren',
  edit_ad_text_1: 'Jetzt Änderungen an Ihrem Inserat vornehmen und anschließend die unverbindliche und kostenfreie Einholung von neuen Kaufangeboten starten.',
  edit_ad_text_2: 'Wir versuchen nach Übermittlung Ihrer Inseratsänderungen und Start der Angebotseinholung innerhalb von 24 Stunden ein TOP-Kaufangebot für Ihr Fahrzeug zu erzielen, während Sie sich entspannt zurücklehnen. Wir informieren Sie per E-Mail, sobald es Neuigkeiten gibt.',
  note: 'Hinweis',
  sell_vstepper_cta: 'Kostenloses Angebot einholen',

  'ad.please_select': 'Bitte wählen...',

  'ad.damage.location_and_type': 'Schadensstelle und Schadenstyp',
  'ad.damage.location_and_type.subtitle': 'Bitte geben Sie an, wo sich der Schaden am Fahrzeug befindet und wählen Sie einen Schadenstyp aus.',

  'ad.images.bullet_1': 'Bilder von außen (wir empfehlen mindestens 5, von allen Seiten)',
  'ad.images.bullet_2': 'Bilder von innen (wir empfehlen mindestens 5, von Fahrerhaus, Betten, Bad etc.)',

  'ad.images.bullet_3.info.link': 'Sie möchten Ihre Bilder per Smartphone hochladen?',
  'ad.images.bullet_3.info': 'Klicken Sie auf die untere Schaltfläche, um eine automatisch generierte E-Mail auszulösen. Diese E-Mail können Sie anschließend in Ihrem Smartphone öffnen und gelangen dann direkt an diese Stelle des Inserats. Von hier aus können Sie Ihr Inserat fortsetzen.',

  'ad.images.bullet_3.action': 'E-Mail auslösen',

  'ad.share.via.email': 'Klicken Sie auf die Schaltfläche, um eine automatisch generierte E-Mail auszulösen. Diese E-Mail können Sie anschließend in Ihrem Computer oder Smartphone öffnen und gelangen dann direkt an diese Stelle des Inserats. Von hier aus können Sie Ihr Inserat fortsetzen.',
  'ad.shared.via.email': 'Email wurde versendet',

  'ad.images.select_images': 'Fahrzeugbilder auswählen',

  'ad.images.registration.bullet_1': 'Bitte übermitteln Sie ein offizielles Dokument, damit wir Ihre gemachten Angaben auf Richtigkeit überprüfen können. Dokumente werden von uns niemals veröffentlicht und dienen nur internen Prüfzwecken. Die Halterdaten dürfen Sie auf Wunsch unkenntlich machen.',
  'ad.images.registration.bullet_2': 'Empfohlenes Dokument: Zulassungsbescheinigung Teil I (“kleiner KFZ-Schein”), alternativ HU-Bericht oder COC-Dokument (Datenblatt des Herstellers)',
  'ad.images.registration.bullet_3': 'Ohne Bereitstellung von mindestens einem offiziellen Dokument können Sie nicht fortfahren.',

  'ad.auction.enter_selling_price': 'Preisvorstellung eingeben',

  'ad.auction.tip.title': 'Entscheidend für den Verkaufserfolg:',
  'ad.auction.tip': 'Setzen Sie eine <strong>realistische</strong> Preisvorstellung. Unser System gleicht Ihren Preis im Hintergrund mit aktuellen Marktdaten ab. Anfragen mit <strong>überzogenen</strong> Preiserwartungen werden nachträglich vom System ohne gesonderte Mitteilung <strong>abgelehnt.</strong>',

  'ad.auction.bullet_1': 'Bitte geben Sie Ihren realistischen Mindestverkaufspreis an. Ihr Mindestverkaufspreis ist für alle Teilnehmer des Bieterverfahrens sichtbar.',
  'ad.auction.bullet_2': 'Wird der Mindestverkaufspreis erreicht oder übertroffen, erfolgt mit Ablauf des Bieterverfahrens automatisch der Verkauf an den Höchstbietenden.',

  'ad.auction.bullet_1.alt': 'Erhalten Sie innerhalb von 24 Stunden ein Kaufangebot in Höhe Ihrer Preisvorstellung, ist Ihr Fahrzeug <strong>verbindlich</strong> verkauft (kostenfrei).',
  'ad.auction.bullet_2.alt': 'Andernfalls erlischt nach Ablauf von 24 Stunden jegliche Verpflichtung Ihrerseits.',
  'ad.auction.bullet_3.alt': 'Tipp: Setzen Sie einen realistischen Preis an, um die Chance auf den Verkauf deutlich zu erhöhen. Auf überzogene Preisvorstellungen erfolgen <strong>keine</strong> Kaufangebote.',

  'ad.auction.bullet_1.alt_anr': 'Bitte geben Sie Ihre realistische Preisvorstellung an',
  'ad.auction.bullet_2.alt_anr': 'Keine Verkaufsverpflichtung, auch falls Ihre Preisvorstellung erreicht oder übertroffen wird',

  'ad.auction.vat': 'MwSt. ausweisbar',
  'ad.auction.vat.tooltip': 'Wählen Sie diese Option, wenn Sie die Mehrwertsteuer auf der Rechnung separat ausweisen können (z.B. als gewerblicher Verkäufer).',
  'ad.auction.vat.bullet_1': 'Nur wenn Sie Ihr Fahrzeug für Ihr Gewerbe angemeldet hatten und Sie außerdem zum Vorsteuerabzug berechtigt sind. Im Falle eines Verkaufs müssen Sie dem Käufer eine gesonderte Rechnung ausstellen.',
  'ad.auction.vat.bullet_2': 'Ist die MwSt. ausweisbar, versteht sich Ihr angegebener Mindestverkaufspreis als Bruttopreis inkl. MwSt.',

  'ad.auction.buy_now': 'Sofortkauf-Option aktivieren',
  'ad.auction.buy_now.bullet_1': 'Ihr Fahrzeug kann vorzeitig zu Ihrem Mindestverkaufspreis gekauft werden.',
  'ad.auction.buy_now.bullet_2': 'Vorteil: Das reguläre Ende des Bieterverfahrens muss nicht abgewartet werden.',
  'ad.auction.buy_now.bullet_3': 'Wir empfehlen, die Sofortkauf-Option zu aktivieren.',

  'ad.auction.available.title': 'Wann kann Ihr Fahrzeug vom potenziellen Käufer abgeholt werden?',
  'ad.auction.available.title.new': 'Übergabezeitpunkt',
  'ad.auction.available.now': 'sofort',
  'ad.auction.available.now.title': 'Sofort verfügbar',
  'ad.auction.available.now.subtitle': 'Das Fahrzeug ist innerhalb kurzer Zeit bereit zur Abholung.',
  'ad.auction.available.later': 'zu späterem Zeitpunkt (maximal 3 Monate)',
  'ad.auction.available.later.title': 'Späterer Zeitpunkt',
  'ad.auction.available.later.subtitle': 'Das Fahrzeug wird noch genutzt, Übergabe kann noch nicht erfolgen (max. 3 Monate).',

  'ad.auction.price.title': 'Ihre Preisvorstellung',
  'ad.auction.hasSellingIntent.new.title': 'Angebotseinholung',
  'ad.auction.hasSellingIntent.new.subtitle': '<strong>Blitzschnell zum Top-Angebot:</strong> Wir holen für Ihr Fahrzeug Kaufangebote bei <strong>über 700</strong> professionellen Fachhändlern ein, um den <strong>bestmöglichen</strong> Preis zu ermitteln. Da Händler ihre Angebote nur bei <strong>ernsthafter Verkaufsabsicht</strong> abgeben, benötigen wir von Ihnen für <strong>maximal 24 Stunden</strong> Planungssicherheit.',
  'ad.auction.hasSellingIntent.new.yes.infobox': '„Klingt fair! Erhalte ich für mein Fahrzeug innerhalb von 24 Stunden ein Kaufangebot in Höhe von <strong>{0} oder mehr</strong>, gebe ich schon jetzt den Verkauf direkt über das Portal frei.“',
  'ad.auction.hasSellingIntent.new.yes.label': 'Vereinbarung bestätigen',
  'ad.auction.hasSellingIntent.new.yes.error': 'Bitte bestätigen Sie die Vereinbarung, um fortzufahren.',
  'ad.auction.hasSellingIntent.new.yes.absolute_free': '100% kostenfrei',

  'ad.auction.hasSellingIntent.new.yes.note.1': '<strong>Volle Flexibilität:</strong> Vereinbarung erlischt <strong>automatisch</strong> nach max. 24 Std.',
  'ad.auction.hasSellingIntent.new.yes.note.2': '<strong>Maximale Sicherheit:</strong> Kein Verkauf unterhalb Ihrer Preisvorstellung',
  'ad.auction.hasSellingIntent.new.yes.note.3': '<strong>Garantiert kostenfrei:</strong> Keine versteckten Gebühren, unabhängig vom Ergebnis',

  'ad.auction.hasSellingIntent.title': 'Verkaufsoption wählen',
  'ad.auction.hasSellingIntent.subtitle': 'Wie möchten Sie Ihr Fahrzeug anbieten? Beide nachfolgenden Optionen sind <strong>garantiert kostenfrei!</strong>',
  'ad.auction.hasSellingIntent.yes.title': 'Premium-Inserat',
  'ad.auction.hasSellingIntent.yes.note.1': 'Maximale Sichtbarkeit und Nachfrage',
  'ad.auction.hasSellingIntent.yes.note.2': '8 - 12 Top-Kaufangebote',
  'ad.auction.hasSellingIntent.yes.note.3': 'Höchste Verkaufswahrscheinlichkeit',
  'ad.auction.hasSellingIntent.yes.infobox': '<strong>Bedingung des Premium-Inserats</strong>:<br/> Der Verkauf erfolgt <strong>automatisch</strong> und ist verbindlich, sofern <strong>innerhalb von 24 Stunden</strong> ein Kaufangebot in Höhe von <strong>mindestens {0}</strong> eingeht. <u>Maximale Sicherheit</u>: Ein Kaufangebot <strong>unterhalb</strong> von {0} löst keinen automatischen Verkauf aus.',

  'ad.auction.recommended': 'Empfohlen',
  'ad.auction.popularChoice': 'Beliebteste Wahl',
  'ad.auction.hasSellingIntent.yes.subtitle': 'Der Verkauf zu meiner Preisvorstellung soll <strong>automatisch</strong> verbindlich erfolgen.',
  'ad.auction.hasSellingIntent.no.title': 'Basis-Inserat',
  'ad.auction.hasSellingIntent.no.note.1': 'Eingeschränkte Sichtbarkeit',
  'ad.auction.hasSellingIntent.no.note.2': '1-3 Kaufangebote',
  'ad.auction.hasSellingIntent.no.note.3': 'Geringere Chance auf den Verkauf',
  'ad.auction.hasSellingIntent.no.subtitle': 'Der Verkauf zu meiner Preisvorstellung soll erst <strong>nach aktiver Zustimmung</strong> erfolgen.',
  'ad.auction.hasSellingIntent.no.infobox': 'Der Verkauf zu Ihrer Preisvorstellung erfolgt <strong>nicht automatisch</strong> und erst nach Ihrer <strong>aktiven Zustimmung</strong>',

  'ad.auction.hasSellingIntent.dialog.title': 'Verschenken Sie kein Geld!',
  'ad.auction.hasSellingIntent.dialog.paragraph': '<strong>Sind Sie sicher?</strong> Fahrzeuge mit Basis-Inserat erhalten im Durchschnitt ein <strong>um 12 % niedrigeres Kaufangebot</strong>, da keine klar erkennbare Verkaufsabsicht besteht.',
  'ad.auction.hasSellingIntent.dialog.info_box': '<strong>92% wählen das Premium-Inserat</strong>',
  'ad.auction.hasSellingIntent.dialog.feature1.title': 'Kein Risiko und volle Flexibilität',
  'ad.auction.hasSellingIntent.dialog.feature1.subtitle': 'Wird Ihre Preisvorstellung nicht innerhalb von 24h erreicht, verkaufen Sie auch nicht.',
  'ad.auction.hasSellingIntent.dialog.confirm_yes': 'Premium-Inserat aktivieren',
  'ad.auction.hasSellingIntent.dialog.confirm_yes.mobile': 'Premium-Inserat aktivieren',
  'ad.auction.hasSellingIntent.dialog.stay_no': 'Auf höhere Angebote verzichten',

  'ad.auction.available_now': 'Fahrzeug sofort verfügbar',

  'ad.auction.available_now.available_at.title': 'Abholdatum',
  'ad.auction.available_now.available_at.placeholder': 'Datum wählen',

  'ad.auction.available_now.available_at': 'abholbereit zum',

  'ad.auction.expected_mileage.title': 'Geschätzter Km-Stand bei Übergabe',
  'ad.auction.expected_mileage.placeholder': 'Kilometerstand eingeben',

  'ad.auction.available_now.bullet_1': 'Nach erfolgtem Online-Verkauf kann das Fahrzeug sofort bzw. zeitnah vom Käufer abgeholt werden',
  'ad.auction.available_now.bullet_2': 'Nach erfolgtem Online-Verkauf ist das Fahrzeug ab dem unten angegebenen Zeitpunkt abholbereit.',

  'ad.auction.available_now.bullet_1.alt': 'Im Verkaufsfall ist das Fahrzeug sofort bzw. zeitnah verfügbar.',
  'ad.auction.available_now.bullet_2.alt': 'Im Verkaufsfall ist das Fahrzeug ab dem unten angegebenen Zeitpunkt abholbereit.',

  'ad.auction.available_now.bullet_1.alt_anr': 'Falls Sie sich für den Verkauf entscheiden, ist Ihr Fahrzeug sofort bzw. zeitnah verfügbar.',
  'ad.auction.available_now.bullet_2.alt_anr': 'Falls Sie sich für den Verkauf entscheiden, ist Ihr Fahrzeug ab dem unten angegebenen Zeitpunkt abholbereit.',

  'ad.auction.location_pickup.new.title': 'Abholstandort',
  'ad.auction.location_pickup.new.location_pickup_is_customer_address.yes.title': 'Wohnsitz',
  'ad.auction.location_pickup.new.location_pickup_is_customer_address.yes.title.merchant': 'Firmensitz',
  'ad.auction.location_pickup.new.location_pickup_is_customer_address.yes.subtitle': 'Abholung bequem bei Ihnen zuhause.',

  'ad.auction.location_pickup.new.location_pickup_is_customer_address.no.title': 'Abweichender Standort',
  'ad.auction.location_pickup.new.location_pickup_is_customer_address.no.subtitle': 'Abholung an abweichender Adresse.',

  'ad.auction.location_pickup_is_customer_address': 'Abholstandort entspricht Wohnsitz / Firmensitz',

  'ad.auction.location_pickup_is_customer_address.text': 'Abweichenden Standort angeben:',
  'ad.auction.location_pickup': 'Standort des Fahrzeugs',

  'ad.auction.almost_done': 'Fast geschafft! Nur noch ein letzter Schritt.',

  'ad.auction.static_review.name': 'Michael Bohrmann (Bremen)',
  'ad.auction.static_review.review': 'Habe meinen Wunschpreis erzielt. Seriöse Abwicklung!',

  'ad.auction.tac.accept': 'Ich stimme den {0} und den {1} zu.',
  'ad.auction.expected_mileage': 'Wie ist der geschätzte Kilometerstand zum angegebenen Abholtermin? Bitte um möglichst genaue Schätzung, im Zweifel höher schätzen als niedriger (Empfehlung).',

  'ad.more_information.text.placeholder': 'Bitte detailliert beschreiben',
  'ad.more_information.tip.title': 'Warum diese Angaben wichtig sind',
  'ad.more_information.tip.text': 'Transparenz schafft Vertrauen. Detaillierte Angaben zu Ihrem Fahrzeug vermeiden Rückfragen und erhöhen die Chance auf einen höheres Kaufangebot. Bitte beantworten Sie nach Möglichkeit alle Fragen. Für die Beantwortung haben Sie nur wenige Minuten Zeit.',

  'ad.more_information.validation.text': 'Bitte mindestens eine Frage beantworten',

  'ad.int_no': 'Int Nr.',
  'ad.incl_19_vat': 'inkl. 19% MwSt.',
  'ad.incl_x_vat': 'inkl. {0}% MwSt.',
  'ad.end_of_auction': 'Auktionsende',
  'ad.provision': 'Provision',
  'ad.provision.net': 'netto',
  'ad.provision.gross': 'brutto',

  'ad.loading': 'Inserat wird geladen',

  'ad_intake.images.uploading': 'Ihre Bilder werden hochgeladen, bitte warten!',
  'ad_intake.images.uploading.error': 'Fehler beim Hochladen einiger Bilder. Bitte versuchen Sie die fehlgeschlagenen Bilder erneut hochzuladen.',

  'ad_intake.last_step.nl.instruction.1': 'Ich bestätige hiermit, der Eigentümer des inserierten Fahrzeugs zu sein bzw. für den Verkauf bevollmächtigt zu sein.',
  'ad_intake.last_step.nl.instruction.2': 'bla bla bla',
  'ad_intake.last_step.nl.instruction.3': 'bla bla bla bla',

  'ad_intake.vat_checkbox_confirmation.title': 'Sind Sie ein Privatverkäufer oder ein gewerblicher Verkäufer?',
  'ad_intake.vat_checkbox_confirmation.yes': 'Ich bin Privatverkäufer',
  'ad_intake.vat_checkbox_confirmation.no': 'Ich bin gewerblicher Verkäufer',
  'ad_intake.confirmation_popup.four_wheel_drive': 'Sind Sie sicher, dass Ihr Fahrzeug über einen Allradantrieb (4x4) verfügt?',

  'ad_intake.confirmation_popup.yearly_leak_test': 'Sind Sie sicher, dass für Ihr Fahrzeug jährlich bzw. lückenlos gemäß Herstellervorgabe alle erforderlichen Aufbau-Dichtigkeitsprüfungen fristgerecht durchgeführt wurden?',

  'ad_intake.confirmation_popup.leak_test_yearly': 'Sind Sie sicher, dass für Ihr Fahrzeug jährlich bzw. lückenlos gemäß Herstellervorgabe alle erforderlichen Aufbau-Dichtigkeitsprüfungen fristgerecht durchgeführt wurden?',
  'ad_intake.confirmation_popup.service_and_inspection': 'Sind Sie sicher, dass für Ihr Fahrzeug gemäß Herstellervorgabe alle erforderlichen Wartungen fristgerecht durchgeführt und im Serviceheft eingetragen wurden?',
  'ad_intake.confirmation_popup.text': 'Sind Sie sicher, dass diese Angabe korrekt ist?',
  'ad_intake.confirmation_popup.damage_images_delete': 'Sind Sie sicher, dass Sie die bereits hochgeladenen Bilder von Mängeln wieder löschen wollen?',

  'ad_intake.confirmation_popup.power': 'Sind Sie sicher, dass die angegebene Motorleistung ({0} kW bzw. {1} PS) korrekt ist?',

  'ad_intake.confirmation_popup.upgrade_particulate_filter': 'Nur relevant bei Fahrzeugen mit Schadstoffklasse EURO 2 oder EURO 3 (mit gelber Feinstaubplakette).',
  'ad_intake.confirmation_popup.air_condition_independent': 'Eine Stand- bzw. Dachklimaanlage ist eine nachgerüstete Anlage speziell für den Wohnraum. Nicht gemeint ist die Klimaanlage des Aufbaufahrzeuges im Fahrerhaus.',
  'ad_intake.confirmation_popup.winterproof': 'Dieses Merkmal nur anwählen, wenn der doppelte Boden beheizt ist. Nicht gemeint ist eine Fußbodenheizung.',
  'ad_intake.confirmation_popup.vat_reportable': 'Nur gewerbliche Verkäufer können die Mehrwertsteuer ausweisen. Sind Sie Privatperson, verkaufen Sie ohne Mehrwertsteuer.',

  'ad_intake.confirmation_popup.defects_exists': 'Sind Sie sicher, dass Ihr Fahrzeug keine erwähnenswerten Mängel (optisch / technisch) aufweist, die für eine potenzielle Kaufentscheidung von Bedeutung wären?',

  'ad_intake.confirmation_popup.smokers_car': 'Sind Sie sicher, dass es sich um ein Raucherfahrzeug handelt?',

  'ad_intake.planned_date_of_sale.title': 'Wann möchten Sie verkaufen?',
  'ad_intake.planned_date_of_sale.description': 'Wählen Sie den Verkaufszeitpunkt für Ihr Wohnmobil oder Ihren Wohnwagen.',
  'ad_intake.planned_date_of_sale.now.title': 'Sofort',
  'ad_intake.planned_date_of_sale.later.title': 'In ein paar Wochen',

  'ad_intake.product_type_selection.title': 'Was möchten Sie verkaufen?',
  'ad_intake.product_type_selection.description':
    'Wählen Sie aus, welchen Fahrzeugtyp Sie verkaufen möchten.',

  'ad_intake.import_or_create_selection.title':
    'Neu anlegen oder importieren?',
  'ad_intake.import_or_create_selection.description':
    'Legen Sie Ihr Inserat neu an oder übertragen Sie ein bereits bestehendes Inserat von einem anderen Verkaufsportal.',

  'ad_intake.import.title': 'Importieren',
  'ad_intake.import.description': 'Importieren Sie Ihr bestehendes Inserat von einem anderen Verkaufsportal.',

  'ad_intake.auction.title': 'Hinweise zum Verkauf',
  'ad_intake.auction.description': 'So wird Ihr Verkaufsinserat ein Erfolg.',

  'ad_intake.titles.product_type_selection': 'Was möchten Sie verkaufen?',
  'ad_intake.titles.import_or_create_selection':
    'Neu anlegen oder importieren?',
  'ad_intake.titles.import': 'Importieren',
  'ad_intake.titles.create_ad': 'Womit möchten Sie beginnen?',
  'ad_intake.titles.continue_ad': 'Inserat weiter bearbeiten',

  'ad_intake.titles.auction': 'Hinweise zur Auktion',

  'ad_intake.description.import':
    'Importieren Sie Ihr bestehendes Inserat von einem anderen Verkaufsportal.',

  'ad_intake.description.auction': 'Zum Ersten, zum Zweiten, zum Dritten! So wird Ihre Auktion ein Erfolg.',

  'social.fb_description_owner':
    'Ich versteigere mein gebrauchtes Wohnmobil einfach und schnell auf caravanmarkt24.de zum Höchstgebot an einen professionellen Händler.',
  'social.fb_description_bidder':
    'Gebrauchtes Wohnmobil auf caravanmarkt24.de einfach und schnell zum Höchstgebot an einen professionellen Händler zu versteigern.',

  'ad_intake.description.bullet_1': 'Beschreiben Sie Ihr Fahrzeug so umfassend wie möglich.',

  'ad_intake.description.bullet_2': 'Heben Sie Besonderheiten und wichtige Informationen hervor.',

  'ad_intake.description.bullet_3': 'Vorhandene Mängel beschreiben Sie erst im nächsten Schritt.',
  'ad_intake.free_offer_email': 'Wohin sollen wir kostenfrei das Angebot zusenden?',
  'ad_intake.phone_number': 'Unter welcher Telefonnummer sind Sie für wichtige Rückfragen erreichbar? (freiwillige Angabe, <strong>empfohlen</strong>)',
  'ad_intake.agreement': 'Mit dem Absenden der Anfrage erklären Sie sich damit einverstanden, E-Mails mit einem Preisangebot und weiteren Informationen zu erhalten. Sie können sich jederzeit aus dem Verteiler austragen.',

  'links.start': 'Startseite',
  'links.catalog': 'Kaufen',
  'links.sell': 'Verkaufen',
  'links.account': 'Mein Konto',
  'links.merchant': 'Händler',
  'links.merchant.url': '/handel',
  'links.merchantListing': 'Händler Verzeichnis',
  'links.pricing': 'Preise',
  'links.faq': 'Häufige Fragen',
  'links.about': 'Über uns',
  'links.contact': 'Kontakt',
  'links.agb': 'AGB',
  'links.privacy': 'Datenschutz',
  'links.imprint': 'Impressum',
  'links.jobs': 'Jobs',
  'links.blog': 'Ratgeber',
  'links.partner': 'Partner',
  'links.inform': 'Informieren',

  'links.slugs.profile': 'profil',
  'links.slugs.notes': 'hinweise',
  'links.slugs.steps': 'schritte',
  'links.slugs.sell': 'verkaufen',
  'links.slugs.import': 'importieren',
  'links.slugs.new_or_import': 'neu-oder-importieren',
  'links.slugs.equipment': 'ausstattung',
  'links.slugs.images': 'bilder',
  'links.slugs.description': 'beschreibung',
  'links.slugs.defects': 'maengel',
  'links.slugs.auction': 'auktion',

  'ad.title': 'Verkaufsinserat erstellen',
  'ad.description': 'Wohnmobil oder Wohnwagen in unter 24 Stunden Tagen online zum Höchstgebot verkaufen',

  'ad.continue': 'Inserat weiter bearbeiten',
  'ad.new.please_register': 'Bitte registrieren Sie sich, um fortzufahren, es dauert nur 30 Sek.',
  'ad.register.fast': 'Es dauert nur 30 Sekunden.',

  'ad.optional_fields.tooltip': 'Die unten aufgeführten Felder können Sie auf Wunsch vervollständigen, um die Qualität Ihres Inserats zu erhöhen.',

  'ad.date_of_sale.title': 'Wann möchten Sie verkaufen?',
  'ad.date_of_sale.description': 'Wählen Sie den Verkaufszeitpunkt für Ihr Wohnmobil oder Ihren Wohnwagen.',

  'ad.date_of_sale.now.title': 'Direktverkauf: Kurzfristig verkaufen bei Erreichen Ihres Mindestverkaufspreises',
  'ad.date_of_sale.now.check_1': 'Ihr Fahrzeug steht sofort oder innerhalb von max. 6 Wochen zur Verfügung',
  'ad.date_of_sale.now.check_2': 'Wir holen für Sie Ankaufsangebote von über 250 Fachhändlern ein (kostenfreies Online-Bieterverfahren)',

  'ad.date_of_sale.now.description': 'Ihr Fahrzeug steht kurzfristig zum Verkauf (sofort oder innerhalb von einigen Wochen). Es werden innerhalb von 24 Stunden Gebote von über 250 Fachhändlern eingeholt (Online-Bieterverfahren).',
  'ad.date_of_sale.later.title': 'Schnell-Bewertung: Zu späterem Zeitpunkt verkaufen',
  'ad.date_of_sale.later.check_1': 'Wir ermitteln kostenfrei den aktuellen Wert Ihres Freizeitfahrzeugs in Form einer Preisspanne (z.B. 50.000 - 55.000 €)',
  'ad.date_of_sale.later.check_2': 'Keine Einholung von konkreten Geboten von Fachhändlern, kein sofortiger Verkauf möglich',

  'ad.date_of_sale.later.description': 'Sie wissen noch nicht, wann Sie Ihr Fahrzeug verkaufen möchten. Sie haben lediglich Interesse an einer kostenfreien Wertermittlung. Sie erhalten von uns eine Preisschätzung in Form einer Spanne (z.B. 50.000 - 55.000 €). Es werden keine Gebote von Fachhändlern eingeholt, ein Verkauf ist nicht möglich.',

  'ad.product_type_selection.motorhome': 'Ich möchte ein Wohnmobil verkaufen',
  'ad.product_type_selection.trailer': 'Ich möchte einen Wohnwagen verkaufen',
  'ad.import_or_create.create': 'Neues Inserat erstellen',
  'ad.create.popup.title': 'Neues Inserat erstellen',
  'ad.create.popup.text': 'Das Erstellen eines neuen Inserats für dasselbe Fahrzeug ist nicht gestattet. Möchten Sie Änderungen an Ihrem bestehenden Inserat vornehmen, kontaktieren Sie uns bitte per {0} oder über unser {1}.',
  'ad.create.popup.text.contactEmail': 'E-Mail',
  'ad.create.popup.text.contactForm': 'Kontaktformular',
  'ad.create.popup.cta': 'Neues Inserat erstellen',

  'ad.import_or_create.import': 'Bereits bestehendes Inserat importieren',

  'ad.import.kleinanzeigen': 'Datenimport von Kleinanzeigen',
  'ad.import.rdw': 'Datenimport von https://www.rdw.nl',

  'ad.import.rdw.loading.text.1': 'Wir übertragen Ihre Fahrzeugdaten für das Kennzeichen {0} von https://opendata.rdw.nl',
  'ad.import.rdw.loading.text.2': 'Im nächsten Schritt können Sie Ihre Fahrzeugdaten weiter bearbeiten.',

  'ad.import.rdw.noLicensePlate': 'Ich kenne mein Kennzeichen nicht',
  'ad.import.rdw.loading.text.alert.1': 'Für das Kennzeichen {0} konnten wir leider keine Fahrzeugdaten auf https://opendata.rdw.nl finden.',
  'ad.import.rdw.loading.text.alert.2': 'Im nächsten Schritt können Sie jedoch ganz einfach Ihre Fahrzeugdaten hinterlegen.',

  'ad.import.timesaver': 'Zeit sparen durch Übertragen von Inseratsdaten und Bildern',
  'ad.import.howitworks': 'So funktioniert’s: Öffnen Sie Ihr Inserat auf eBay Kleinanzeigen, kopieren Sie die vollständige Adresszeile (URL) oder die Anzeigen-ID Ihres Inserats und fügen Sie diese unten ein. Anschließend starten Sie den Import.',
  'ad.import.howitworks.rdw': 'Kennzeichen eingeben und Import starten',
  'ad.import.howlong': 'Der Import dauert ca. 30 Sekunden',
  'ad.auction.notes.title': 'Wichtige Hinweise zum Bieterverfahren',
  'ad.auction.notes.personal_data': 'Ihre persönlichen Daten sind uns sehr wichtig: Solange es nicht zu einem Verkauf kommt, ist den Bietern Ihre Identität nicht bekannt.',
  'ad.auction.notes.within24h': 'Nach der Absendung prüfen wir Ihr Inserat so schnell wie möglich (innerhalb von maximal 24h) und schalten es danach sofort für das Online-Bieterverfahren frei. Inseratsprüfungen finden auch am Wochenende statt.',
  'ad.auction.notes.will_receive_email': 'Über die erfolgte Freischaltung werden Sie per E-Mail informiert. Bitte prüfen Sie ggf. auch Ihren "Spam-Ordner". Das Bieterverfahren läuft nach der Freischaltung maximal 24 Stunden und endet immer wochentags (Mo - Fr) in der Zeit von 14 bis 17 Uhr.',

  'ad.auction.notes.have_questions': 'Vorab noch Fragen? Rufen Sie uns gern an unter',
  'ad.auction.notes.mo_to_fr': '(Mo - Fr von 9:00 bis 17:00 Uhr)',
  'ad.auction.lower_target_price': 'Preisvorstellung senken',
  'ad.auction.lower_target_price_anr': 'Preisvorstellung senken',
  'ad.auction.lower_target_price.subtitle': 'Senken Sie jetzt den Mindestverkaufspreis, um die Chance auf den Verkauf zu erhöhen.',
  'ad.auction.lower_target_price.subtitle_anr': 'Senken Sie jetzt Ihre Preisvorstellung, um die Chance auf den Verkauf zu erhöhen.',

  'ad.steps.x_of_y': 'Schritt {0} von {1}',
  'ad.steps.my_data': 'Kostenfreies Nutzerkonto anlegen',
  'ad.steps.last_step': 'Letzter Schritt',
  'ad.steps.last_step.subtitle': 'Laden Sie bitte ein offizielles Dokument hoch, damit wir Ihre Angaben auf Richtigkeit überprüfen können.',

  'ad.steps.last_step.x_satisfied_customers': 'Bereits über <strong>100.000 vermittelte Kaufangebote</strong>.<br>Exzellente Kundenzufriedenheit: <strong>4.9 / 5</strong>',
  'ad.steps.last_step.faq': 'Häufige Fragen',

  'ad.vehicle_data': 'Fahrzeugdaten',
  'ad.basic_data': 'Basisdaten',
  'ad.engine': 'Antrieb',
  'ad.environment': 'Umwelt',
  'ad.condition': 'Zustand',
  'ad.inspection': 'Inspektion',
  'ad.equipment': 'Auststattung',
  'ad.details': 'Details',
  'ad.other': 'Weitere',

  'ad.defects.step_1_1': 'Legen Sie alle Ihnen bekannten Mängel offen.',
  'ad.defects.step_1_2': 'Achten Sie auf eine detaillierte Beschreibung der Mängel',

  'ad.defects.upload_images_select': 'Bilder von Mängeln hochladen?',

  'ad.defects.step_2_1': 'Wir empfehlen, Bilder von vorhandenen Mängeln hochzuladen',
  'ad.defects.step_2_2': 'Liegen Bilder vor, können die Schäden genauer kalkuliert werden',

  'ad.select_image': 'Bild auswählen',
  'ad.last_step': 'Inserat absenden',
  'ad.last_step.description': 'Jetzt absenden',

  'ad.last_step.alt': 'Anfrage abschließen',

  'ad.downstream.more_information': 'Inseratsqualität erhöhen',
  'ad.downstream.remaining_time': 'Verbleibende Zeit',

  'ad.downstream.more_information.subtitle.general_damage': 'Behobener Unfallschaden',
  'ad.downstream.more_information.subtitle.general_damage_not_repaired': 'Bestehender Unfallschaden',
  'ad.downstream.more_information.subtitle.water_damage': 'Behobener Wasserschaden',
  'ad.downstream.more_information.subtitle.water_damage_not_repaired': 'Bestehender Wasserschaden',
  'ad.downstream.more_information.subtitle.hail_damage': 'Behobener Hagelschaden',
  'ad.downstream.more_information.subtitle.hail_damage_not_repaired': 'Bestehender Hagelschaden',

  'ad.downstream.more_images': 'Weitere Bilder hochladen',

  'ad.downstream.submit.validation.text': 'Sie haben keine weiteren Bilder übermittelt',
  'ad.downstream.submit.validation.cta': 'Bilder hochladen',
  'ad.downstream.submit.validation.back': 'Später ergänzen',
  'ad.downstream.damage_more_information': 'Inseratsqualität erhöhen: Details nachtragen',

  'ad.downstream.nav.damage_more_information': 'Inseratsqualität erhöhen',

  'ad.last_step.page_title': 'Interne Prüfung Ihrer Inseratsangaben',
  'ad.last_step.page_title.nl': 'Inserat abschliessen',
  'ad.last_step.page_title.alt': 'Anfrage abschließen: Dokument hochladen',

  'ad.anr.stop_auction': 'Angebotseinholung beenden',
  'ad.anr.stop_auction.with_bid.text': 'Sind Sie sicher, dass wir die kostenfreie und unverbindliche Angebotseinholung beenden sollen? Das aktuelle Kaufangebot in Höhe von {0} verfällt endgültig. Ihnen entgeht die Chance, weitere (höhere) Kaufangebote für Ihr Fahrzeug zu erhalten. Sind Sie sicher?',
  'ad.anr.stop_auction.no_bid.text': 'Sind Sie sicher, dass wir die kostenfreie und unverbindliche Angebotseinholung beenden sollen? Ihnen entgeht die Chance, TOP-Kaufangebote für Ihr Fahrzeug zu erhalten. Sind Sie sicher?',
  'ad.anr.stop_auction.cancel': 'Angebotseinholung fortsetzen',
  'ad.anr.stop_auction.submit': 'Angebotseinholung beenden',
  'ad.anr.stop_auction.success.confirmation': 'Wir haben wunschgemäß die Angebotseinholung beendet. Sie können jederzeit Ihre Meinung ändern und Kaufangebote neu einholen.',

  'ad.confirm_auction_cancellation': 'Möchten Sie diese Auktion wirklich abbrechen?',

  'ad.last_step.page_title.new': 'Fast geschafft: Jetzt das Inserat absenden!',
  'ad.last_step.page_title.subtext': 'So geht es weiter:',

  'ad.last_step.page_title.merchant.new': ' Letzter Schritt: Inserat absenden',

  'ad.last_step.text': 'Jetzt das Inserat absenden und innerhalb weniger Stunden ein TOP-Kaufangebot erhalten.',
  'ad.last_step.process.one.text': 'Kostenfrei absenden',
  'ad.last_step.process.one.subtext': 'Dauert nur Sekunden',
  'ad.last_step.process.two.text': 'Entspannt zurücklehnen',
  'ad.last_step.process.two.subtext': 'Für max. 24 Stunden',
  'ad.last_step.process.three.text': 'Kaufangebot erhalten',
  'ad.last_step.process.three.subtext': 'Bequem online verkaufen',

  'ad.last_step.greenbox.1': 'Garantiert kostenfrei und ohne versteckte Gebühren',
  'ad.last_step.greenbox.2': 'Kaufangebot liegt oft schon innerhalb weniger Stunden vor',
  'ad.last_step.greenbox.3': 'Keine zeitraubenden Telefonate, Besichtigungstermine und Verhandlungen',

  'ad.last_step.sub_text': 'caravanmarkt24 hat bereits erfolgreich über 100.000 Kaufangebote vermittelt. Die Kundenzufriedenheit liegt bei hervorragenden 4.9 / 5 ',
  'ad.last_step.your_ad': 'Ihr Fahrzeug',

  'ad.last_step.rating': 'Exzellent bewertet mit 4.9/5 bei 1000+ Bewertungen',
  'ad.last_step.bullets_title': 'Ihre Vorteile',

  'ad.last_step.bullets_1': 'Kein Verkauf unter {0}',
  'ad.last_step.bullets_2': 'Bequem online anfragen',
  'ad.last_step.bullets_3': 'Garantiert kostenfrei',

  'validation.alpha': '{_field_} darf nur alphabetische Zeichen enthalten',
  'validation.alpha_dash':
    '{_field_} darf alphanumerische Zeichen sowie Striche und Unterstriche enthalten',
  'validation.alpha_num':
    '{_field_} darf nur alphanumerische Zeichen enthalten',
  'validation.alpha_spaces':
    '{_field_} darf nur alphanumerische Zeichen und Leerzeichen enthalten',
  'validation.between': '{_field_} muss zwischen {min} und {max} liegen',
  'validation.confirmed': 'Die Bestätigung von {_field_} stimmt nicht überein',
  'validation.digits':
    '{_field_} muss numerisch sein und exakt {length} Ziffern enthalten',
  'validation.dimensions':
    '{_field_} muss {width} x {height} Bildpunkte groß sein',
  'validation.email': '{_field_} muss eine gültige E-Mail-Adresse sein',
  'validation.excluded': '{_field_} muss ein gültiger Wert sein',
  'validation.ext': '{_field_} muss eine gültige Datei sein',
  'validation.image': '{_field_} muss eine Grafik sein',
  'validation.oneOf': '{_field_} muss ein gültiger Wert sein',
  'validation.integer': '{_field_} muss eine ganze Zahl sein',
  'validation.length': 'Die Länge von {_field_} muss {length}-stellig sein',
  'validation.max': '{_field_} darf nicht länger als {length} Zeichen sein',
  'validation.max_value': '{_field_} darf maximal {max} sein',
  'validation.mimes': '{_field_} muss einen gültigen Dateityp haben',
  'validation.min': '{_field_} muss mindestens {length} Zeichen lang sein',
  'validation.min_value': '{_field_} muss mindestens {min} sein',
  'validation.numeric': '{_field_} darf nur numerische Zeichen enthalten',
  'validation.regex': 'Das Format von {_field_} ist ungültig',
  'validation.required': '{_field_} ist ein Pflichtfeld',
  'validation.required_if': '{_field_} ist ein Pflichtfeld',
  'validation.size': '{_field_} muss kleiner als {size} sein',
  'validation.telephone': '{_field_} muss ein gültige Telefonnummer sein',
  'validation.zip_code': '{_field_} muss eine gültige Postleitzahl sein',
  'validation.importer_link': '{_field_} muss ein gültiges Format haben',
  'validation.dutchLicensePlate': '{_field_} darf nur Großbuchstaben, Bindestriche und Zahlen enthalten',
  'validation.description_min': 'Beschreibung muss mindestens 10 Zeichen lang sein',

  'validation.email_provider': 'Bitte prüfen: Ist Ihre E-Mail-Adresse korrekt?',
  'validation.no_umlaute': 'E-Mail-Adresse darf keine Umlaute enthalten',

  'validation.password': '{_field_} muss mindestens 1 Großbuchstaben, 1 Kleinbuchstaben und 1 Zahl enthalten',

  'validation.min_target_price': 'Ihre Preisvorstellung: {0}. Sind Sie sicher?',

  'attributes.chassis_select': '{value}',
  'attributes.other_series': 'Andere Baureihe',
  'attributes.first_registration_year': 'Jahr der Erstzulassung',
  'attributes.first_registration_month': 'Monat der Erstzulassung',

  'attributes.fuel': '{value}',
  'attributes.air_condition': '{value}',
  'attributes.category': '{value}',
  'attributes.mileage': '{value}',
  'attributes.transmission': '{value}',
  'attributes.trailer_mileage': '{value}',
  'attributes.mileage_last_service': '{value}',
  'attributes.trailer_mileage_last_service': '{value}',
  'attributes.engine_capacity': '{value}',
  'attributes.power': '{value}',
  'attributes.hu_valid_through': 'HU: {value}',
  'attributes.hu_expired': 'HU: abgelaufen',
  'attributes.first_registration': '{value}',

  'attributes.length': '{value}',
  'attributes.width': '{value}',
  'attributes.trailer_width': '{value}',
  'attributes.height': '{value}',
  'attributes.trailer_height': '{value}',
  'attributes.trailer_height_inner': '{value}',

  'attributes.licensed_seats': 'Sitzplätze: {value}',
  'attributes.trailer_hu_valid_through': 'HU: {value}',
  'attributes.trailer_hu_expired': 'HU: abgelaufen',
  'attributes.trailer_length': 'Länge: {value}',
  'attributes.trailer_mover': 'Rangierhilfe: {value}',
  'attributes.trailer_first_registration': '{value}',
  'attributes.trailer_number_of_beds': 'Schlafplätze: {value}',
  'attributes.trailer_anti_fling': 'Antischl.-Kpl: {value}',
  'attributes.trailer_licensed_weight': 'zul. Gew.: {value}',
  'attributes.trailer_axles': 'Achsen: {value}',
  404: '404 Nicht gefunden',
  error: 'Ein Fehler ist aufgetreten',
  no_page: 'Diese Seite existiert nicht',
  logo: 'Logo von caravanmarkt24.de',
  enterprise: 'Unternehmen',
  'footer.platform': 'Plattform',
  'footer.legal': 'Rechtliches',
  'footer.social': 'Social',
  'footer.partner': 'Partner',
  'footer.agb': 'AGB',
  'footer.privacy': 'Datenschutz',
  'footer.imprint': 'Impressum',

  'subscription.success':
    'Vielen Dank für Ihre Anmeldung zu unserem Newsletter rund um den Verkauf gebrauchter Wohnmobile und Wohnwagen.',
  'subscription.error':
    'Es gab ein Problem bei der Verarbeitung Ihrer Anmeldung. Bitte versuchen Sie es erneut oder nehmen Sie Kontakt mit uns über unsere Hilfeseiten auf.',
  filter: 'Filter',
  completed: 'Beendet',
  Sofortkauf: 'Sofortkauf',
  Entfernung: 'Entfernung',
  buy_now_available: 'Sofortkauf möglich',
  'Sofortkauf möglich': 'Sofortkauf möglich',

  Herstellerauktion: 'Herstellerauktion',
  'Exklusive Auktion': 'Exklusive Auktion',

  'filter.mileage': 'Kilometerstand',
  'filter.hail_damaged': 'Hagelschaden',
  'filter.water_damaged': 'Wasserschaden',
  'filter.model_select': 'Modell',
  'catalog.filter.remove_all': 'Alle Filter entfernen',

  no_buy_now_available: 'Kein Sofortkauf',
  signup: 'Registrieren',
  signed_in_as: 'Angemeldet ist:',
  my_account: 'Meine Daten',
  my_messages: 'Meine Nachrichten',
  my_vehicles: 'Meine Fahrzeuge',
  my_watchlist: 'Meine Merkliste',
  no_vehicles_in_watchlist: 'Keine Fahrzeuge in der Merkliste',
  immediately: 'sofort',

  'product.loading': 'Fahrzeug wird geladen',

  merchant_guide: 'Händlerleitfaden',
  merchant_guide_loading: 'Händlerleitfaden wird geladen',
  merchant_notifications: 'Neuigkeiten',
  customer_notifications: 'Einstellungen',
  settings: 'Einstellungen',

  merchant_notification_valid_from: 'Mitteilung vom {0}',

  logout: 'Ausloggen',
  account_data: 'Anmeldedaten',
  user_account: 'Nutzerkonto',
  'user_account.danger': 'Gefahrenzone',
  contact_data: 'Kontaktdaten',
  language: 'Sprache',
  company: 'Firma',
  company_address: 'Firmenadresse',
  legal: 'Rechtliches',
  for_your_information: 'Zur Information',
  cta_done: 'Erledigt',
  cta_to_do: 'Ausstehend',
  address: 'Adresse',

  'messages.complete_your_data': 'Meine Daten vervollständigen',
  'messages.back_to_auction': 'Zurück zur Auktion',
  'messages.my_dealer_guide': 'Mein Händlerleitfaden',
  'messages.go_to_auction': 'Zur Auktion',
  'messages.create_auction_now': 'Jetzt Verkaufsinserat erstellen',

  'messages.invoice': 'Rechnung',
  'messages.contract': 'Kaufvertrag',
  'messages.cancel': 'Stornieren',
  'messages.reversalinvoice': 'Storno-Rechnung',

  'order.cancellation.popup.title': 'Stornierung anfragen',
  'order.cancellation.popup.subtitle': 'Bitte geben Sie den Grund für die Stornierungsanfrage an:',
  'order.cancellation.popup.confirm': 'Ich versichere, wahrheitsgemäße Angaben gemacht zu haben. Mir ist bekannt, dass caravanmarkt24 den Fall prüfen wird und hierzu ggf. auch Kontakt zum Verkäufer aufnimmt.',
  'order.cancellation.defects.details': 'Bitte geben Sie nicht deklarierte Mängel bzw. Abweichungen an:',
  'order.cancellation.popup.error': 'Beim Absenden Ihrer Stornierungsanfrage ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.',
  'order.cancellation.popup.success': 'Vielen Dank für Ihre Mitteilung. Wir werden den Fall prüfen und Sie über das Ergebnis per E-Mail benachrichtigen.',
  'messages.reduce_target_price_and_resubmit.title': 'Erhöhen Sie die Chance auf den Verkauf!',
  'messages.reduce_target_price_and_resubmit.subtitle': 'Starten Sie jetzt ein neues Bieterverfahren und geben Sie erneut mehr als 300 Bietern die Gelegenheit, Ankaufsangebote abzugeben. Bitte legen Sie dazu Ihren neuen Mindestverkaufspreis fest.',
  'messages.reduce_target_price_and_resubmit.subtitle.tooltip': 'Es ist ein Abschlag von mindestens 5 % zum vorherigen Mindestverkaufspreis erforderlich',
  'messages.reduce_target_price_and_resubmit.offer_valid_until': 'Archiviertes Höchstgebot ({0}) gültig bis: {1}',
  'messages.reduce_target_price_and_resubmit.title2': 'Mindestverkaufspreis für neues Bieterverfahren senken um',

  'messages.reduce_target_price_and_resubmit.title2.alt': '{0} (archiviertes Höchstgebot)',

  'messages.reduce_target_price_and_resubmit.cta': 'Bieterverfahren starten',
  'messages.reduce_target_price_and_resubmit.popup.title.hasValidOffer': 'Neues Bieterverfahren mit Mindestverkaufspreis {0} starten?',
  'messages.reduce_target_price_and_resubmit.popup.title': 'Haben sich die Fahrzeugdaten geändert und erfordert Ihr Inserat eine Überarbeitung?',
  'messages.reduce_target_price_and_resubmit.popup.yes': 'Ja, notwendige Änderungen übermittle ich zeitnah per E-Mail',
  'messages.reduce_target_price_and_resubmit.popup.no': 'Nein, Bieterverfahren jetzt starten (Neuer Mindestverkaufspreis: {0})',
  'messages.reduce_target_price_and_resubmit.popup.cancel': 'Abbrechen',
  'messages.reduce_target_price_and_resubmit.popup.cta': 'Jetzt starten',

  'messages.reduce_to_x': '(auf {0}) senken',

  'messages.by_': 'Um',

  'messages.submit_for_new_auction_now': 'Jetzt erneut in die Auktion geben',
  'messages.submit_for_new_auction_with_target_price_x': 'Mit reduziertem Mindestverkaufspreis {0} erneut in die Auktion geben.',
  'messages.latest': 'Neueste Nachricht',

  'countdown.day': 'Tag',
  'countdown.days': 'Tagen',
  'countdown.hour': 'Stunde',
  'countdown.hours': 'Stunden',
  'countdown.minute': 'Minute',
  'countdown.minutes': 'Minuten',
  'countdown.second': 'Sekunde',
  'countdown.seconds': 'Sekunden',

  'reneg.sticky.footer.cta': 'Jetzt Angebot prüfen',

  'reneg.loading': 'Auktionslogik wird geladen',
  'reneg.owner_accept_offer_until_x': 'Angebot annehmen oder Gegenangebot abgeben bis {0} Uhr',
  'reneg.owner_accept_offer_x_or_send_counter_offer': 'Angebot liegt vor, Reaktion ausstehend',
  'reneg.owner_accept_offer_x_or_decline': 'Kaufangebot {0} annehmen oder endgültig ablehnen',
  'reneg.owner_accept_offer_x_until_x': 'Angebot {0} annehmen oder Gegenangebot abgeben bis {1} Uhr',
  'reneg.owner_decrease_counter_offer_or_accept_offer_until_x': 'Angebot {0} annehmen oder reduziertes Gegenangebot senden',
  'reneg.owner_accept_anr_offer_until_x': 'Angebot annehmen bis {0} Uhr',

  'reneg.merchant_accept_offer_until_x': 'Verkaufsangebot annehmen oder neues Kaufangebot abgeben bis {0} Uhr',
  'reneg.time_left_x_until_offer_expires_at_x': 'Es bleiben Ihnen {0}, bis das Angebot am {1} verfällt.',
  'reneg.time_left': 'Es bleiben Ihnen',
  'reneg.until_offer_expires': ' bis das Angebot verfällt.',
  'reneg.canceled_at': 'Nachverhandlung abgebrochen am',
  'reneg.accept_buying_offer_of_x': 'Verbindliches Kaufangebot zum Preis von {0} annehmen',
  'reneg.accepted_offer_message_for_seller': 'Herzlichen Glückwunsch zum Verkauf! Bitte prüfen Sie Ihr E-Mail-Postfach, wir haben Ihnen soeben alle wichtigen Informationen zum Verkauf sowie den Kaufvertrag und die Daten des Käufers zugesendet.',

  'reneg.decline_offer_not_available_anymore': 'Ihr Fahrzeug steht nicht mehr zum Verkauf. Wir beenden die Suche nach Kaufangeboten und wünschen Ihnen alles Gute.',
  'reneg.decline_offer_and_restart_message_for_seller': 'Wir holen ab sofort weitere Angebote für Sie ein, während Sie sich entspannt zurücklehnen. Bitte beachten Sie unsere E-Mail mit allen weiteren Informationen.',

  'reneg.selling_offer': 'Gegenangebot des Verkäufers:',
  'reneg.your_selling_offer': 'Ihr Verkaufsangebot',
  'reneg.your_last_selling_offer': 'Ihr letztes Gegenangebot',

  'reneg.accept_selling_offer_of_x': 'Verbindliches Verkaufsangebot zum Preis von {0} annehmen',
  'reneg.accept_offer_x': 'Für {0} verkaufen',
  'reneg.accept_counter_offer_x': 'Gegenangebot {0} annehmen',
  'reneg.accept_offer': 'Angebot annehmen',
  'reneg.yes_accept_offer': 'Ja, Angebot annehmen',
  'reneg.yes_accept_counter_offer': 'Ja, Gegenangebot annehmen',
  'reneg.make_new_buying_offer': 'Neues Kaufangebot machen',
  'reneg.direct_bid': 'Direktgebot',
  'reneg.reneg_offer_label': 'Angebot',
  'reneg.submit_counter_offer': 'Gegenangebot absenden',
  'reneg.submit_counter_offer_x': 'Gegenangebot {0} absenden',
  'reneg.submit_offer': 'Kaufangebot absenden',
  'reneg.yes_submit_counter_offer': 'Ja, Gegenangebot absenden',
  'reneg.make_counter_offer': 'Gegenangebot machen',
  'reneg.counter_offer': 'Gegenangebot',
  'reneg.counter_offer.input': 'Gegenangebot eingeben',
  'reneg.or_increase_offer': 'Proaktiv Gebot erhöhen',
  'reneg.or_increase_offer_cta': 'Gebot erhöhen',
  'reneg.submit_decreased_counteroffer': 'Gegenangebot reduzieren',

  'reneg.submit_buying_offer_of_x': 'Verbindliches Kaufangebot zum Preis von {0} absenden',
  'reneg.submit_selling_offer_of_x': 'Verbindliches Verkaufsangebot zum Preis von {0} absenden',

  'reneg.decline_selling_offer_of_x_and_cancel': 'Verbindliches Verkaufsangebot zum Preis von {0} ablehnen und Nachverhandlung beenden?',

  'reneg.decline_buying_offer_of_x_and_cancel': ' Kaufangebot {0} endgültig ablehnen?',

  'reneg.your_counter_offer_x_is_submitted_you_can_still_accept_offer_x': 'Ihr Gegenangebot {0} wurde erfolgreich übermittelt, wir wünschen Ihnen viel Glück! <strong>Hinweis:</strong> Sie können jederzeit das aktuell vorliegende Angebot {1} annehmen oder ein neues, reduziertes Gegenangebot senden, falls der Kaufinteressent nicht reagiert.',
  'reneg.your_offer_x_is_submitted_you_can_still_increase': 'Ihr Kaufangebot {0} wurde erfolgreich übermittelt, wir wünschen Ihnen viel Glück! <strong>Hinweis:</strong> Sie können jederzeit Ihr Kaufangebot verbessern, um die Chance auf den Kauf zu erhöhen, falls der Verkäufer nicht auf Ihr aktuelles Kaufangebot reagiert. ',

  'reneg.submit_buying_offer': 'Kaufangebot absenden',
  'reneg.yes_submit_buying_offer': 'Ja, Kaufangebot absenden',
  'reneg.decline_offer': 'Nachverhandlung beenden',
  'reneg.decline_offer.popup.title': 'Angebot ablehnen',
  'reneg.decline_anr_offer_above_targetprice': 'Angebot endgültig ablehnen',

  'reneg.decline_late_offer': 'Kein Interesse',
  'reneg.decline_offer_cta': 'Angebot ablehnen',
  'reneg.yes_decline_offer': 'Ja, Angebot ablehnen',
  'reneg.yes_decline_offer_and_restart': 'Weitere Angebote erhalten',
  'reneg.yes_decline_offer_and_pause': 'Gebotseinholung pausieren',
  'reneg.yes_decline_offer_and_pause_above': 'Angebotseinholung pausieren',
  'reneg.yes_decline_offer_x_and_restart': '{0} ablehnen',
  'reneg.yes_decline_offer_and_dont_restart': 'Nachverhandlung beenden',
  'reneg.yes_decline_offer_not_available_anymore': 'Fahrzeug nicht mehr verfügbar',
  'reneg.yes_decline_offer_price_too_low': 'Kaufangebot zu niedrig',
  'reneg.yes_decline_offer_price_too_low_dont_restart': 'Kaufangebot zu niedrig. Keine weiteren Angebote erhalten',
  'reneg.yes_decline_transferred_offer_note': '<strong>Hinweis</strong>: Wenn Sie jetzt ablehnen, wird das aktuelle Höchstgebot {0} endgültig gelöscht. Wir empfehlen Ihnen statt des Ablehnens mit dem Kaufinteressenten online nachzuverhandeln, indem Sie ein Gegenangebot an diesen senden.',

  'reneg.set_selling_offer': 'Gegenangebot einstellen',

  'reneg.accept_buying_offer': 'Kaufangebot annehmen',
  'reneg.not_available': 'Nicht mehr verfügbar',
  'reneg.not_available.popup.text': 'Ihr Fahrzeug steht nicht mehr zum Verkauf. Das vorliegende Gebot jetzt endgültig ablehnen?',
  'reneg.make_offer': 'Kaufangebot einstellen',
  'reneg.you_can_increase_offer': 'Proaktiv Kaufangebot erhöhen bis {0} Uhr',
  'reneg.buying_offer': 'Kaufangebot',
  'reneg.make_buying_offer': 'Kaufangebot einstellen',
  'reneg.increase_offer_cta': 'Gebot erhöhen',
  'reneg.open_dialog': 'Nachverhandeln',
  'reneg.open_dialog.decrease': 'Gegenangebot reduzieren',

  'not_selling.dialog.title': 'Vielen Dank für Ihr Interesse an einem Kaufangebot',
  'not_selling.dialog.text': 'Da zum aktuellen Zeitpunkt keine Verkaufsabsicht besteht, können wir Ihnen leider kein Kaufangebot unterbreiten. Der Markt ist sehr dynamisch, Preise unterliegen stärkeren Schwankungen. Bitte fahren Sie mit Ihrer Anfrage daher erst dann wieder fort, sobald Sie den zeitnahen Verkauf beabsichtigen.',

  'not_selling.dialog.back.text': 'Ich habe meine Meinung geändert und möchte zeitnah verkaufen',
  'not_selling.dialog.back.cta': 'Kaufangebot jetzt einholen',

  'not_selling.dialog.submit.text': 'Ich möchte erst zu einem späteren Zeitpunkt verkaufen oder habe keine Verkaufsabsicht',
  'not_selling.dialog.submit.cta': 'Anfrage zurückstellen',

  'account.delete': 'Account löschen',
  'account.delete.text': 'Wollen Sie wirklich Ihr Nutzerkonto, sämtliche gespeicherten Daten und Ihren Zugang zu caravanmarkt24 unwiderruflich löschen?',
  'account.delete.yes': 'Ja, jetzt löschen',
  'account.delete.no': 'Abbrechen',
  'account.delete.error.general': 'Es ist ein Fehler bei der Löschung Ihres Nutzerkontos aufgetreten. Bitte versuchen Sie es erneut.',
  'account.delete.success': 'Ihr Nutzerkonto und sämtliche gespeicherten Daten wurden unwiderruflich gemäß Datenschutzverordnung gelöscht. Wir wünschen Ihnen alles Gute!',
  'account.delete.error.contact_support': 'Bitte kontaktieren Sie unseren Support, um Ihre Löschanfrage zu bearbeiten.',

  'account.my_data': 'Persönliche Daten',
  'account.my_address': 'Adresse',
  'account.delete_my_data': 'Kontaktdaten löschen',

  'account.commercial.company': 'Firma',
  'account.commercial.company.address': 'Firmenadresse',

  'account.save_error': 'Es ist ein Fehler beim Speichern Ihrer Daten aufgetreten. Bitte versuchen Sie es erneut.',
  'account.fields_missing_error': 'Bitte füllen Sie alle Pflichtfelder aus.',

  'account.email_automation.title.VALUATION_REPORT_REMINDER': 'Schnellbewertung',
  'account.email_automation.title.COMPLETE_AD_REMINDER': 'Inserat vervollständigen',
  'account.email_automation.title.FAILED_AUCTION_REMINDER': 'Kaufangebot neu einholen',

  'account.saved_searches': 'Keine gespeicherten Suchen vorhanden',
  'account.saved_searches_loading': 'Ihre gespeicherten Suchen werden geladen',
  'account.saved_searches_per_page': 'Suchen pro Seite',
  'account.saved_searches_receive_per_mail': 'Neue Suchergebnisse per Email erhalten',
  'account.edit.new_name': 'Neuer Name für Ihren Suchauftrag',

  'catalog.saved_search_editing': 'Aktuellen Suchauftrag bearbeiten',

  'account.loading': 'Ihre Daten werden geladen',

  'account.complete_message': 'Bitte vervollständigen Sie Ihre persönlichen Daten, damit Ihr Nutzerkonto freigeschaltet werden kann und wir das Bieterverfahren nach der Prüfung {0} starten können.',
  'account.your_ad': 'Ihres Inserats',
  'account.your_auction': 'Ihre Auktion',
  'account.email_address': 'E-Mail-Adresse',

  'account.email_address_verified': 'E-Mail-Adresse bestätigt',

  'account.i_am': 'Ich bin',
  'account.private_seller': 'Privatverkäufer',
  'account.commercial_seller': 'gewerblicher Verkäufer',

  'account.commercial_seller.tooltip_1': 'Sie verkaufen ein gewerblich genutztes bzw. angemeldetes Fahrzeug aus einer gewerblichen Tätigkeit.',
  'account.commercial_seller.tooltip_2': 'Der Mindestverkaufspreis bzw. Zuschlagspreis versteht sich als Bruttopreis.',
  'account.commercial_seller.tooltip_3': 'Im Falle eines Zuschlags sind Sie verpflichtet, dem Käufer eine Rechnung mit ausgewiesener Mehrwertsteuer auszustellen.',

  'account.register': 'registrieren',
  'account.register_as_merchant': 'Der Kauf ist zum jetzigen Zeitpunkt nur für professionelle Händler möglich. Jetzt {0}',
  'account.your_registration_is_being_reviewed': 'Ihre Registrierung wird von unserem Team geprüft. Sobald wir Sie freigeschaltet haben, können Sie auf Fahrzeuge bieten.',

  'account.update': 'Hinterlegen',
  'account.update_as_merchant': '{0} Sie Ihre Daten als Händler, um auf Fahrzeuge zu bieten.',
  'account.personal_data': 'Persönliche Daten',
  'account.personal_data.email': 'E-Mail-Adresse',
  'account.personal_data.password': 'Passwort',

  'account.merchant': 'Händler',
  'account.merchant.accepted_tos': 'Ja, ich habe die {0} und die {1} gelesen und stimme diesen zu. (*)',
  'account.merchant.tos': 'Allgemeinen Geschäftsbedingungen',
  'account.merchant.privacy': 'Datenschutzbestimmungen',

  'account.merchant.email_settings': 'E-Mail Benachrichtigungen',
  'account.merchant.email_settings.change': 'E-Mail Einstellungen ändern',

  'account.merchant.newcomer_email': 'Neuzugänge / wieder verfügbar',
  'account.merchant.anr_newcomer_email': 'Automatische Folgerunden',

  'account.merchant.newcomer_email.locations.title': 'Fahrzeugstandorte',

  'account.private.notification_settings': 'Benachrichtigungen',
  'account.private.notification_settings.change': 'Benachrichtigungseinstellungen ändern',
  'account.private.settings': 'Einstellungen',
  'account.private.settings.change': 'Einstellungen ändern',

  'account.private.notification_settings.whatsapp': 'WhatsApp',
  'account.private.notification_settings.whatsapp.change': 'WhatsApp Einstellungen',
  'account.private.notification_settings.whatsapp.notifications': 'Kaufangebot und Online-Nachverhandlung',
  'account.private.notification_settings.whatsapp.notifications.other': 'Sonstige WhatsApp-Nachrichten',

  'order.status.paid': 'Bezahlt',
  'order.status.canceled': 'Storniert',
  'order.status.pending': 'Offen',
  'order.status.cancellation_requested_by_dealer': 'Storno angefragt',

  'order.payment.due_by': 'Rechnung fällig spätestens am {0}',
  'order.payment.overdue': 'Rechnung überfällig',

  choose_language: 'Sprache wählen',

  email_automation_settings: 'Email Einstellungen',

  complete_profile:
    'Bitte vervollständigen Sie Ihre Angaben als Händler unter \'Meine Daten\' und warten Sie auf Ihre Freischaltung.',

  your_versioned_ad_popup_title: 'Inseratsqualität erhöhen',
  your_versioned_ad_popup_text: 'Bitte beantworten Sie noch einige Detailfragen zum Zustand Ihres <strong>{0}</strong> Fahrzeugs (dauert nur wenige Minuten), um die Chance auf <strong>ein höheres Kaufangebot</strong> zu erhalten. ',

  'your_versioned_ad_popup_title.images': 'Weitere Bilder hochladen',
  'your_versioned_ad_popup_text.images': 'Sie haben nur wenige Bilder für Ihr <strong>{0}</strong> Fahrzeug bereitgestellt. Wir empfehlen zeitnah weitere Bilder hochzuladen, um die Inseratsqualität zu erhöhen und die Chance auf ein höheres Kaufangebot zu erhalten.',

  your_versioned_ad_popup_cta: 'Daten ergänzen',
  your_versioned_ad_popup_cancel: 'Kein Interesse',

  'your_versioned_ad_popup_cta.images': 'Jetzt hochladen',
  'your_versioned_ad_popup_cancel.images': 'Kein Interesse',

  your_ad_was_submitted_and_is_under_review:
    'Ihre Anfrage wurde erfolgreich übermittelt. Wir prüfen und verarbeiten Ihre Daten. Weitere Informationen erhalten Sie in Kürze per E-Mail. Bitte prüfen Sie auch Ihren Spam-Ordner.',

  your_versioned_ad_was_submitted_and_is_under_review:
    'Vielen Dank, die Ergänzungen zu Ihrem Inserat wurden übermittelt und werden zeitnah geprüft.',

  email_address_verified: 'Vielen Dank, Ihre E-Mail-Adresse ist jetzt bestätigt.',

  please_confirm_your_email_address:
    'Bitte bestätigen Sie Ihre E-Mail-Adresse, damit Ihr Nutzerkonto aktiviert werden kann. Sie haben dazu systemseitig eine E-Mail erhalten. Bitte prüfen Sie auch Ihren Spam-Ordner.',
  sms_code_sent_to: 'SMS-Code gesendet an: <strong>{0}</strong>',
  sms_code_sent_to_mobile: 'SMS-Code gesendet an:<br> <strong>{0}</strong>',
  sms_not_received: 'Code nicht erhalten?',
  sms_send_again: 'Erneut senden',
  sms_send_again_at: 'Erneut senden in {0}s',
  sms_approve: 'Bestätigen',
  sms_phone_approved: 'Erfolgreich bestätigt!',
  please_verify_your_phone: 'Wir legen großen Wert auf Sicherheit. Bestätigen Sie bitte jetzt Ihre Telefonnummer.',
  trade_registration_is_uploading: 'Ihre Gewerbeanmeldung wird hochgeladen',
  'rate_limiting.sms_phone_day': 'Es wurden heute bereits die maximale Anzahl an SMS-Codes an diese Nummer gesendet. Bitte versuchen Sie es morgen erneut oder kontaktieren Sie unseren Support, um Ihre Telefonnummer zu bestätigen.',
  'rate_limiting.sms_ip_hour': 'Es wurden bereits die maximale Anzahl an SMS-Codes von dieser IP-Adresse gesendet. Bitte versuchen Sie es in einer Stunde erneut oder kontaktieren Sie unseren Support, um Ihre Telefonnummer zu bestätigen.',
  delete_contact_data: 'Kontaktdaten löschen',
  change: 'ändern',
  'md/owner': 'Geschäftsführer/Inhaber',
  contact_person: 'Ansprechpartner',

  my_integrations: 'Meine Integrationen',
  'my_integrations.aktiv': 'aktiv',
  'my_integrations.not_installed': 'nicht installiert',
  'my_integrations.configure_now': 'Jetzt konfigurieren',
  'my_integrations.delete_integration': 'Integration löschen',

  my_ads: 'Meine Inserate',
  my_searches: 'Suchaufträge',
  my_purchases: 'Meine Käufe',
  no_vehicles_in_my_purchases: 'Noch keine Fahrzeuge gekauft',
  no_entries: 'Keine Einträge',
  no_title: 'Kein Titel',

  'my_searches.details': 'Details',
  'my_searches.name': 'Name',
  'my_searches.status': 'Status',
  'my_searches.updated_at': 'Zuletzt aktualisiert',
  'my_searches.delete': 'Löschen',

  watchlist: 'Merkliste',
  accept: 'Ich akzeptiere',
  account_deactivated:
    'Ihr Account wurde temporär deaktiviert. Bitte setzen Sie sich mit unserem Service Team in Kontakt.',
  'title.your_motorhome': 'Ihr Wohnmobil',
  'title.your_camper_van': 'Ihren Campervan',
  'title.your_caravan': 'Ihren Wohnwagen',
  current_auctions: 'Aktuell im Verkauf',
  auction_last: 'Verkaufte Wohnmobile und Wohnwagen',
  create_auction: 'Jetzt Auktion erstellen',
  play_video: 'Video abspielen',
  video_unsupported:
    'Leider unterstützt Ihr Browser keine eingebetteten Videos.',
  vehicle: 'Fahrzeug',
  review: 'Customer Review',
  to_next: 'Gehen Sie zum nächsten {0}',
  to_prev: 'Gehen Sie zum vorherigen {0}',
  question_error:
    'Beim Verschicken der Frage an den Fahrzeughalter ist ein Problem aufgetreten. Bitte versuchen Sie es erneut.',
  bidding_agent: 'Bietagent',
  bidding_agent_active: 'Bietagent aktiv',
  signup_now: 'Jetzt kostenlos registrieren',
  phone: 'Telefonnummer',
  email: 'E-Mail',
  'email.notifications': 'E-Mail Benachrichtigungen',
  'whatsapp.notifications': 'WhatsApp Benachrichtigungen',
  learn_more: 'Mehr erfahren',
  redirecting: 'Sie werden weitergeleitet.',
  results: 'Ergebnisse',
  save: 'Speichern',
  cancel: 'Abbrechen',
  new: 'Neuer',
  new_label: 'Neu',
  customer_expectation: 'Kundenerwartung',
  customer_expectation_with_selling_intent: 'Freigabepreis',
  customer_expectation_without_selling_intent: 'Vorbehaltspreis',
  old_target_price: 'Alter Preis',

  'customer_expectation_with_selling_intent.tooltip': 'Bei Erreichen des Freigabepreises garantiert der Verkäufer den Verkauf zu diesem Preis (automatischer Verkauf).',
  'customer_expectation_without_selling_intent.tooltip': 'Bei Erreichen des Vorbehaltspreises muss der Verkäufer das Angebot erst freigeben (kein automatischer Verkauf).',

  'customer_expectation.description_1':
    'Die "Kundenerwartung" entspricht dem Mindestverkaufspreis, den der Verkäufer bei der Inseratserstellung festlegen muss. Verkäufer geben erfahrungsgemäß oft höhere Mindestverkaufspreise an, als sie tatsächlich erzielen möchten.',
  'customer_expectation.description_2':
    'Wird die Kundenerwartung durch Ihr Gebot erreicht oder übertroffen, erfolgt mit Auslauf der Auktion automatisch der Zuschlag zu Ihrem Höchstgebot (keine "Online-Nachverhandlung"). Liegt Ihr Höchstgebot nach Auktionsende unter der Kundenerwartung, können Sie als Höchstbietender mit dem Verkäufer online nachverhandeln und das Fahrzeug ggf. unter dem Kundenerwartungspreis bzw. zu Ihrem letzten Höchstgebot erwerben.',
  caravan: 'Wohnwagen',
  to: 'auf',

  'onboarding.leadingTitle.vmm.valuated': 'Jetzt fehlende Daten vervollständigen und ein kostenfreies Verkaufsinserat für Ihr {0} Fahrzeug erstellen',
  'onboarding.title.vmm.valuated': 'Die Wertermittlung zu Ihrem Fahrzeug ist {0} abrufbereit',
  'onboarding.title.vmm.valuated.here': 'hier',
  'onboarding.cta.vmm.valuated': 'Zum Verkaufsinserat',

  'onboarding.leadingTitle.vmm.under_review': 'Jetzt fehlende Daten vervollständigen und ein kostenfreies Verkaufsinserat für Ihr {0} Fahrzeug erstellen',
  'onboarding.title.vmm.under_review': 'Wertermittlung für Ihr {0} Fahrzeug {1}',
  'onboarding.title.vmm.under_review.in_progress': 'in Bearbeitung',
  'onboarding.cta.vmm.under_review': 'Zum Verkaufsinserat',

  'onboarding.title.vmm.editing': 'Kostenlose Wertermittlung anfragen: Es fehlen nur noch wenige Daten',
  'onboarding.cta.vmm.editing': 'Zur Bewertungsanfrage',

  'onboarding.title.ad.editing': 'Kostenloses Verkaufsinserat fertigstellen: Es fehlen nur noch wenige Daten',
  'onboarding.cta.ad.editing': 'Zum Verkaufsinserat',

  'onboarding.title.vmm.else': 'Kostenlose Wertermittlung',
  'onboarding.title.ad.else': 'Kostenloses Verkaufsinserat',
  'onboarding.cta.ad.else': 'Kostenlos Gebote einholen',
  'onboarding.cta.ad.else.new': 'Kaufangebot einholen',
  'onboarding.cta.vmm.else': 'Kostenlos Gebote einholen',
  'onboarding.importing_from_rdw': 'Wir importieren Ihre Fahrzeugdaten von RDW, bitte warten',

  'valuation.status.editing': 'nicht abgeschlossen',
  'valuation.status.under_review': 'in Bearbeitung',
  'valuation.status.valuated': 'abrufbereit',

  'ad.onboarding.product_type': 'Fahrzeugtyp',
  'ad.onboarding.first_registration_year': 'Erstzulassung (Jahr)',

  'ad.onboarding.subtitle': 'Jetzt ganz einfach Daten zu Ihrem Wohnmobil oder Wohnwagen hinterlegen und sofort Ankaufsangebote erhalten!',

  'valuation.form.title': 'In nur 3 Minuten zur kostenlosen Wohnmobil-Bewertung',

  'valuation.form.description': 'Geben Sie ganz einfach und unverbindlich die erforderlichen Daten zu Ihrem Wohnmobil an. Wir ermitteln daraufhin innerhalb von 24 Stunden den aktuellen Marktwert und senden Ihnen das Ergebnis per E-Mail zu. Kostenfrei, unverbindlich und ohne Angabe von persönlichen Daten!',

  'valuation.form.step_1.title': 'Eckdaten des Wohnmobils',
  'valuation.form.step_2.title': 'Historie und Pflegezustand',
  'valuation.form.step_3.title': 'Bewertung abschließen',

  'valuation.form.extra_equipment': 'Besondere Ausstattung',
  'valuation.form.optional_fields': '(Keine Pflichtangaben)',

  'valuation.form.image_upload': 'Bilder hochladen',
  'valuation.form.optional_fields_2': '(nicht verpflichtend, nur falls zur Hand)',
  'valuation.form.your_email': 'Ihre E-Mail-Adresse, damit wir Ihnen das Ergebnis kostenlos zusenden können',

  'valuation.form.your_phone': 'Ihre Telefonnummer für Rückfragen (keine Pflichtangabe).',
  'valuation.form.your_phone.why': 'Wir empfehlen das Hinterlassen Ihrer Telefonnummer, damit wir Sie für ggf. auftretende Rückfragen zu Ihrem Wohnmobil kontaktieren können, um eine genauere Bewertung zu gewährleisten.',
  'valuation.form.accept': 'Mit dem Absenden der Bewertungsanfrage erkläre ich mich damit einverstanden, E-Mails bezüglich der Bewertung und weitere Informationen zu erhalten. {0}',
  'valuation.form.goto_tac': 'Datenschutzerklärung ansehen',

  'valuation.form.misc': 'Sonstige Anmerkungen',
  'valuation.form.submit': 'Bewertungsanfrage absenden',

  'valuation.success.title': 'Vielen Dank für Ihre Bewertungsanfrage ✅',
  'valuation.success.pretext': 'Daten übermittelt!',
  'valuation.success.text': 'Uns erreichen aktuell sehr viele Bewertungsanfragen. Wir bearbeiten Ihre Anfrage so schnell wie möglich, im Regelfall innerhalb von 24 Stunden. Das Ergebnis senden wir Ihnen per E-Mail zu, bitte prüfen Sie auch Ihren Spam-Ordner.',

  'valuation.success.h2': 'Nach Erhalt der Wertermittlung zum Verkauf anbieten?',
  'valuation.success.profitip': 'Profi-Tipp: Exakten Verkaufspreis Ihres {0} Wohnmobils ermitteln',

  'valuation.success.checks_1': '100% kostenfreier und sicherer Online-Verkauf über das Portal caravanmarkt24',
  'valuation.success.checks_2': 'Ohne Telefonate, Besichtigungstermine, Probefahrten und nervenaufreibende Preisverhandlungen',
  'valuation.success.checks_3': 'Bereits über 5.000 Freizeitfahrzeuge online verkauft',

  'valuation.report.checks_1': 'Inserat erstellen und Ankaufsangebote von über 250 Fachhändlern einholen',
  'valuation.report.checks_2': 'Bequem von zuhause ohne Besichtigungen, Probefahrten und Feilschen',
  'valuation.report.checks_3': 'Schnelle Gebotseinholung im Online-Bieterverfahren in max. 24 Stunden',
  'valuation.report.checks_4': 'Keine Verkaufspflicht bei Geboten unter Ihrem Mindestverkaufspreis',
  'valuation.report.checks_5': 'Für Verkäufer 100% kostenlos und ohne Gewährleistungsrisiko',

  'valuation.success.info_1': 'Bereits über 3.000 Online-Bieterverfahren erfolgreich durchgeführt',
  'valuation.success.info_2': 'Jetzt Daten vervollständigen und Verkaufsinserat erstellen (in unter 15 Minuten)',
  'valuation.success.info_3': 'Für Verkäufer zu 100% kostenlos',

  'valuation.success.easy': 'So einfach haben Sie noch nie verkauft ...',

  'valuation.report.create_ad_now.why': 'Fehlende Daten und Mindestverkaufspreis in nur 10 Minuten ergänzen',

  'valuation.success.create_ad_now': 'Jetzt Daten vervollständigen',
  'valuation.success.more_information': 'Weitere Informationen',

  'valuation.report.title': 'Schnell-Bewertung',
  'valuation.report.pretext': 'Schätzung des Verkaufspreises Ihres Wohnmobils',
  'valuation.trailer.report.pretext': 'Schätzung des Verkaufspreises Ihres Wohnwagens',
  'valuation.report.data': 'Eckdaten',
  'valuation.report.date': 'Stand',
  'valuation.report.explanation.short': 'Empfohlener Verkaufspreis (basierend auf Ihren Angaben)',
  'valuation.report.explanation.short.more': 'Sie können ggf. auch einen höheren Preis erzielen',

  'valuation.report.explanation.impossible': '(Die Bewertung verzögert sich leider, da aktuell nicht genug Vergleichs- und Transaktionsdaten zu ähnlichen Fahrzeugen in unserer Datenbank zur Verfügung stehen.)',
  'valuation.report.explanation': 'Die Bewertung basiert auf einem vereinfachten Online-Bewertungsverfahren und ersetzt nicht eine gründliche Bewertung nach Prüfung aller relevanten und preisbildenden Faktoren. Die ausgewiesene Preisspanne kann daher nur eine Schätzung darstellen, Ihnen jedoch gleichzeitig einen Hinweis für den realistischen Verkaufspreis geben.',
  'valuation.report.video.leadingSubtitle': 'Erklärvideo ansehen',
  'valuation.report.video.title': 'Ablauf erklärt in nur 60 Sekunden',
  'valuation.report.teaser': 'Möchten Sie schnell und unverbindlich den <span class="font-weight-bold">exakten</span> Marktwert Ihres {0} Wohnmobils erfahren und bei Bedarf zum bestmöglichen Preis unkompliziert und sicher verkaufen? Dann vervollständigen Sie jetzt ganz einfach die fehlenden Daten und geben Sie in weniger als 10-15 Minuten ein <span class="font-weight-bold">kostenloses</span> Verkaufsinserat auf.',

  'valuation.report.advantages': 'Jetzt einfach online verkaufen',

  'valuation.trailer': 'Wohnwagen Wertermittlung',
  'valuation.trailer_data': 'Eckdaten des Wohnwagens',
  'valuation.provide_trailer_data': 'Geben Sie ganz einfach und unverbindlich die erforderlichen Daten zu Ihrem Wohnwagen an. Wir ermitteln daraufhin innerhalb von 24 Stunden den aktuellen Marktwert und senden Ihnen das Ergebnis per E-Mail zu. Kostenfrei, unverbindlich und ohne Angabe von persönlichen Daten!',
  'valuation.email_used': 'Es wurde bereits eine Bewertung mit dieser E-Mail-Adresse abgegeben.',
  'valuation.error': 'Es ist ein Fehler aufgetreten. Bitte versuchen Sie es später erneut.',

  'auction.started': 'Auktion wird gestartet',
  'auction.starts': 'Auktion beginnt in',
  'auction.ended': 'Diese Auktion ist ausgelaufen',
  'auction.ends': 'Auktion endet in',
  'auction.late_offer_ends': 'Kaufangebot gültig bis',

  'auction.archived_bid_notification': 'Gebotsarchivierung: Gehen Sie als Höchstbieter aus einer gescheiterten Auktion bzw. Online-Nachverhandlung hervor, gilt Ihr Höchstgebot gemäß AGB verbindlich fort bis zum Ablauf der Folgerunde inklusive der sich anschließenden Nachverhandlung.',
  'auction.late_bid_notification': 'Bitte beachten Sie: An den Verkäufer wird nur 1 <strong>gültiges</strong> Gebot übermittelt. Ihr Gebot ist erst gültig, wenn es auf Höhe der hinterlegten Systemvorgabe für das Mindestgebot liegt. Ist Ihr Gebot zu niedrig und wird vom System abgelehnt, können Sie ein höheres Gebot abgeben. Geben Sie jetzt Ihr bestes Gebot ab!',

  'auction.late_bid_popup.text': 'Sie sind für 48 Stunden verbindlich an dieses Gebot gebunden. Falls der Verkäufer Ihnen ein Gegenangebot sendet und damit in die Online-Nachverhandlung eintritt, gelten die entsprechenden Fristen der Online-Nachverhandlung.',
  'auction.archived_bid_notification.link': 'Weitere Informationen',

  'auction.archived_bid_notification.watchlist': 'Ihr archiviertes Gebot {0} gilt verbindlich bis {1} Uhr.',
  'auction.archived_bid_notification.watchlist.ran_out': 'Bindungsfrist für archiviertes Gebot ({0}) verstrichen, Gebot gelöscht',

  'auction.archived_bid_notification.countdown': 'Archiviertes Höchstgebot <span class="font-weight-bold">{0}</span> nur noch gültig für',
  'auction.simple_count_down.valid_until': 'bis {0} Uhr',
  'auction.simple_count_down.hours': 'Std.',
  'auction.late_offer_unavailable': 'Das Angebot ist nicht verfügbar',
  'auction.bid_too_high': 'Ihr Gebot ist zu hoch',
  'auction.bidding_not_possible': 'Kein Gebot möglich',
  'auction.you_were_overbid': 'Sie wurden überboten.',
  'auction.archived_bid': 'Archivierte Gebote',

  'agb.popup.title': 'Änderungen vom {0}',

  'landing.onboarding.login_form.title': 'Anmelden',
  'landing.onboarding.login_form.subtitle': 'Sie sind bereits mit der angegebenen E-Mail-Adresse registriert. Bitte melden Sie sich an, um fortzufahren.',

  'landing.onboarding.ad_intake.target_price': 'Preisvorstellung',
  'landing.onboarding.ad_intake.cta.alt': 'Zum Verkaufsinserat',

  'landing.onboarding.all_new.patience': 'Bitte haben Sie einen Moment Geduld.',

  'landing.onboarding.all_new.sold_x_today.small': '{0} Anfragen in den letzten 24h',
  'landing.onboarding.all_new.sold_x_today': '{0} Anfragen in den letzten 24 Stunden',
  'landing.onboarding.all_new.choose_product_type': 'Fahrzeug wählen',
  'landing.onboarding.all_new.choose_product_type.small': 'Jetzt Daten eintragen (3 Min)',
  'landing.onboarding.all_new.motorhome': 'Wohnmobil',
  'landing.onboarding.all_new.trailer': 'Wohnwagen',
  'landing.onboarding.all_new.continue': 'Weiter zu den Details',
  'landing.onboarding.all_new.back': 'Zurück',
  'landing.onboarding.all_new.details': 'Fahrzeugdetails',

  'landing.onboarding.all_new.step_x_of_y': 'Schritt {0} von {1}',
  'landing.onboarding.all_new.to_last_step': 'Zum letzten Schritt',

  'landing.onboarding.all_new.your_buying_offer': 'Ihr Kaufangebot',

  'landing.onboarding.all_new.good_news': '<strong>Gute Nachrichten!</strong> Unser System hat {0} Kaufinteressenten für Ihr Fahrzeug gefunden.',

  'landing.onboarding.all_new.where_to_send_the_offer': 'Wohin sollen wir das Angebot zusenden?',

  'landing.onboarding.all_new.telephone': 'Mobilfunknummer',
  'landing.onboarding.all_new.optional_but_recommended': '(Angabe freiwillig, empfohlen)',
  'landing.onboarding.all_new.have_questions': 'Bei wichtigen Rückfragen zu Ihrem Fahrzeug kontaktieren wir Sie gern telefonisch. Garantiert keine Werbeanrufe oder Rufnummernweitergabe!',

  'landing.onboarding.all_new.get_free_offer': 'Kostenloses Angebot einholen',
  'landing.onboarding.all_new.more_than_100000': 'Bereits über 100.000 Kaufangebote unterbreitet',
  'landing.onboarding.all_new.more_than_100000.mobile': 'Bereits 100.000+ Angebote unterbreitet',
  'landing.onboarding.all_new.disclaimer': 'Mit dem Absenden der Anfrage erklären Sie sich damit einverstanden, E-Mails mit einem Preisangebot und weiteren Informationen zu erhalten. Sie können sich jederzeit aus dem Verteiler austragen.',
  'landing.onboarding.all_new.to_tac': 'Datenschutzerklärung ansehen',
  'landing.onboarding.all_new.excellent_reviews': 'Exzellent bewertet: 4.9',
  'landing.onboarding.all_new.based_on_x_reviews': 'Basierend auf 500+ Rezensionen',
  'landing.onboarding.all_new.safe_data_transfer': 'Sichere Datenübertragung',

  'landing.onboarding.all_new.phone_disclaimer': 'Wir legen höchsten Wert auf Sicherheit. Aus diesem Grund müssen wir gewährleisten, dass Ihre Telefonnummer korrekt ist, um Betrug und Datenmissbrauch aktiv zu verhindern.',
  'landing.onboarding.all_new.send_sms_code': 'SMS-Code anfordern',
  'landing.onboarding.all_new.enter_sms_code': 'Bestätigungscode eingeben',
  'landing.onboarding.all_new.we_sent_you_code': 'Wir haben Ihnen einen 4-stelligen Code an <strong>{phone}</strong> gesendet.',
  code_not_sent: 'Code nicht erhalten',
  wrong_code: 'Der von Ihnen angegebene Code stimmt nicht',
  'landing.onboarding.all_new.code_resend_success': 'SMS erfolgreich erneut gesendet!',
  'landing.onboarding.all_new.forward_message': 'Einen Moment bitte, Sie werden weitergeleitet...',
  'landing.onboarding.labor_text_1': 'Analysiere Fahrzeugdaten...',
  'landing.onboarding.labor_text_2': 'Prüfe Kaufinteressenten...',
  'landing.onboarding.labor_text_3': '{0} passende Kaufinteressenten gefunden',

  'counterOfferDialog.title.confirm': 'Gegenangebot prüfen',
  'counterOfferDialog.title.warning': 'Nachverhandeln',
  'counterOfferDialog.title.warning.decrease': 'Gegenangebot reduzieren',
  'counterOfferDialog.title.accepted': 'Herzlichen Glückwunsch!',

  'counterOfferDialog.warning.pretext': '<strong class="text-uppercase">Vorsicht:</strong> Lehnt der Kaufinteressent Ihr Gegenangebot ab, ist die Nachverhandlung sofort gescheitert und das vorliegende Angebot {0} <strong>erlischt unwiderruflich</strong>.',

  'counterOfferDialog.button.cta': 'Gegenangebot {0} senden',

  'counterOfferDialog.button.sell.cta': 'Verkaufen für {0}',
  'counterOfferDialog.button.confirm.cta': 'Bestätigen',
  'counterOfferDialog.button.sell.cta.safe': 'Sicher verkaufen für {0}',

  'counterOfferDialog.confirm.pre_text': 'Unsere Erfahrungswerte aus über <strong>30.000 betreuten Nachverhandlungen</strong> zeigen folgende <strong>Risiken</strong> bei überzogenen Gegenangeboten:',

  'counterOfferDialog.confirm.list.one': '<strong>Verhandlung scheitert:</strong> 85 % der Kaufinteressenten brechen bei zu hohen Forderungen sofort ab.',
  'counterOfferDialog.confirm.list.two': '<strong>Angebot erlischt unwiderruflich:</strong> Verkäufer gehen leer aus, falls der Kaufinteressent ablehnt.',
  'counterOfferDialog.confirm.list.three': '<strong>Weniger Geld:</strong> Nur 2 von 10 Verkäufern erzielen bei erneuter Angebotseinholung ein Angebot in gleicher Höhe, 8 von 10 erhalten ein niedrigeres Angebot als vorher.',
  'counterOfferDialog.confirm.your_counter_offer': 'Ihr Gegenangebot',

  'counterOfferDialog.confirm.success': 'Gegenangebot in Höhe von {0}  wurde übermittelt.',

  'counterOfferDialog.accepted.success': 'Erfolg: Fahrzeug wurde zum Preis von {0}  verkauft.',

  'counterOfferDialog.accepted.pretext': 'Sie haben Ihr Fahrzeug für {0} erfolgreich verkauft! Damit ist ein verbindlicher Kaufvertrag zwischen Ihnen und dem Käufer zustande gekommen. Wir haben Ihnen soeben alle wichtigen Informationen sowie den Kaufvertrag zusätzlich per E-Mail gesendet.',
  'counterOfferDialog.accepted.download': 'Kaufvertrag herunterladen',
  'counterOfferDialog.accepted.buyer.data': 'Käuferdaten',
  'counterOfferDialog.accepted.buyer.company': 'Firma',
  'counterOfferDialog.accepted.buyer.contact': 'Ansprechpartner',
  'counterOfferDialog.accepted.buyer.address': 'Adresse',
  'counterOfferDialog.accepted.buyer.email': 'E-Mail',
  'counterOfferDialog.accepted.buyer.phone': 'Telefon',

  'counterOfferDialog.accepted.next_steps': 'Weiterer Ablauf',
  'counterOfferDialog.accepted.next_steps.one': 'Nehmen Sie zeitnah Kontakt zum Käufer auf und stimmen Sie den Abholtermin ab.',
  'counterOfferDialog.accepted.next_steps.two': 'Drucken Sie den vorausgefüllten Kaufvertrag aus. Eine Unterschrift ist nicht erforderlich.',
  'counterOfferDialog.accepted.next_steps.three': 'Am vereinbarten Abholtag wird der Käufer Ihr Fahrzeug bei Ihnen vor Ort besichtigen und dabei insbesondere die von Ihnen gemachten Angaben mit dem tatsächlichen Zustand abgleichen. Bitte geben Sie dem Käufer hierfür die erforderliche Zeit.',
  'counterOfferDialog.accepted.next_steps.four': 'Nach erfolgtem Geldeingang händigen Sie das Fahrzeug bitte aus.',
  'counterOfferDialog.accepted.to_overview': 'Zurück zur Übersicht',

  'counterOfferDialog.antonia.text': '"Haben Sie Fragen zum Ablauf oder sind Sie sich unsicher? Ich berate Sie gerne persönlich, bevor Sie eine Entscheidung treffen."',

  'counterOfferDialog.contact.phone': 'Telefon',
  'counterOfferDialog.contact.times': 'Mo. bis Fr. von 9 bis 17 Uhr',

  'counterOfferDialog.footer.list.one': 'Rechtssicherer Kaufvertrag ohne Fallstricke',
  'counterOfferDialog.footer.list.two': 'Kostenfreie Abholung bei Ihnen vor Ort',
  'counterOfferDialog.footer.list.three': 'Sichere Blitzüberweisung auf Ihr Bankkonto',

  'landing.hero.item_1': 'Schnelle Gebotseinholung in max. 24 Stunden',
  'landing.hero.item_2':
    'Ohne Besichtigungen, Probefahrten und Preisverhandlungen',
  'landing.hero.item_3':
    'Für Verkäufer 100% kostenlos und ohne Gewährleistungsrisiko',
  'landing.hero.item_4':
    'Keine Verkaufspflicht bei Geboten unter Ihrem Mindestverkaufspreis',
  'landing.hero.item_5':
    'Für Verkäufer 100% kostenlos und ohne Gewährleistungsrisiko',

  'landing.cta': 'Kostenlos Gebote einholen',
  'landing.cta.caption': 'Jetzt ganz einfach <span class="font-weight-bold">in unter 15 Minuten</span> die erforderlichen Daten zu Ihrem Wohnmobil oder Wohnwagen hinterlegen und <span class="font-weight-bold">sofort</span> Gebote erhalten',

  'landing.sell_now': 'Jetzt verkaufen',
  'landing.evaluate': 'Kostenlose Schnell-Bewertung',
  'landing.advantages.caption': 'Warum caravanmarkt24?',
  'landing.advantages.title': 'Vorteile beim Online-Wohnmobilverkauf',
  'landing.advantages.text':
    'Nie war es angenehmer, Ihr Wohnmobil zu verkaufen!',
  'landing.advantages.top_price': 'TOP-Preis',

  'landing.advantages.top_price.item_1':
    'Verkauf im aussichtsreichen Online-Bieterverfahren',
  'landing.advantages.top_price.item_2':
    'Mehr Wettbewerb um Ihr Wohnmobil oder Ihren Wohnwagen als bei konventionellen Verkaufsmethoden',
  'landing.advantages.top_price.item_3':
    'Ohne nervenaufreibende Preisverhandlungen, stattdessen verbindlicher Zuschlagspreis',
  'landing.advantages.easy_sale': 'Einfacher Verkauf',
  'landing.advantages.easy_sale.item_1':
    'Innerhalb kürzester Zeit ein Verkaufsinserat erstellen und Ankaufsangebote von Fachhändlern erhalten',
  'landing.advantages.easy_sale.item_2':
    'Minimaler Verkaufsaufwand ohne ermüdende Telefonate und Besichtigungstermine',
  'landing.advantages.easy_sale.item_3':
    'Verkauf komplett online und bequem von zuhause innerhalb eines Tages möglich',
  'landing.advantages.easy_sale.item_4':
    'Reibungslose Abwicklung durch vertrauenswürdigen Fachhändler',
  'landing.advantages.safety': 'Kostenfrei und sicher',
  'landing.advantages.safety.item_1':
    'Für Verkäufer zu 100% ohne Kosten und Gewährleistungsrisiken',
  'landing.advantages.safety.item_2':
    'Sie bestimmen den Mindestverkaufspreis, keine Gefahr eines ungewollten Verkaufs',
  'landing.advantages.safety.item_3':
    'Anonymität während des Verkaufsprozesses. Freigabe Ihrer persönlichen Daten nur nach erfolgtem Online-Verkauf',
  'landing.advantages.safety.item_4':
    'Übergabe Ihres Wohnmobils oder Wohnwagens erst nach Zahlungseingang',
  'landing.how.caption': 'Reibungsloser Ablauf',
  'landing.how.title': 'So funktioniert\'s',
  'landing.how.text': 'In 4 einfachen Schritten zum Verkauf',
  'landing.how.image': 'Ein Screenshot der Produktseite von caravanmarkt24.de',
  'landing.how.ad_creation': 'Inserat erstellen',
  'landing.how.ad_creation.item_1':
    'Eingabe aller wichtigen Daten und Ausstattungen zu Ihrem Wohnmobil oder Wohnwagen',
  'landing.how.ad_creation.item_2':
    'Beschreibung von Besonderheiten und ggf. vorhandenen Mängeln',
  'landing.how.ad_creation.item_3': 'Hinzufügen von aussagekräftigen Bildern',
  'landing.how.auction': 'Online-Bieterverfahren',
  'landing.how.auction.item_1':
    'Fachhändler geben Gebote auf Ihr Fahrzeug ab',
  'landing.how.auction.item_2':
    'Bieterverfahren bringt den besten Marktpreis Ihres Wohnmobils oder Wohnwagens hervor',
  'landing.how.auction.item_3':
    'Mit Ende des Bieterverfahrens Übermittlung des Höchstgebots an Sie',
  'landing.how.surcharge': 'Verkauf',
  'landing.how.surcharge.item_1':
    'Sofortiger Verkauf bei Erreichen Ihres Mindestverkaufspreises nach Ende des Bieterverfahrens',
  'landing.how.surcharge.item_2':
    'Alternativ auf Wunsch mit dem Höchstbieter online nachverhandeln, falls Ihr Mindestverkaufspreis nicht erreicht wurde',
  'landing.how.surcharge.item_3':
    'Mit Verkauf automatische Erstellung eines rechtssicheren Kaufvertrags (Verkauf unter Ausschluss der Gewährleistung)',
  'landing.how.payment': 'Zahlung und Übergabe',
  'landing.how.payment.item_1':
    'Zeitnahen Abholtermin für Ihr Reisemobil oder Ihren Caravan mit dem Käufer vereinbaren',
  'landing.how.payment.item_2':
    'Abgleich der Angaben aus dem Verkaufsinserat mit dem Zustand vor Ort durch den Käufer',
  'landing.how.payment.item_3':
    'Blitzschnellen Zahlungseingang (per Echtzeitüberweisung) auf Ihrem Bankkonto prüfen und Fahrzeug übergeben',
  'landing.reviews.title': 'Zufriedene Verkäufer',
  'landing.reviews.text':
    'Schauen Sie Videos und lesen Sie Rezensionen von unseren Kunden, die über ihre Erfahrungen beim Verkauf ihres Wohnmobils oder Wohnwagens mit caravanmarkt24 berichten und dabei äußerst zufrieden waren.',
  'landing.reviews.num': '130+ Bewertungen',
  'landing.reviews.view': 'Customer Review anzeigen',
  'landing.products.caption': 'So könnte Ihr Verkaufsinserat aussehen',

  'landing.products.text':
    'Sehen Sie, welche Reisemobile, Caravans und Camper Verkäufer wie Sie aktuell anbieten',
  'landing.products.view_all': 'Alle Fahrzeuge ansehen',
  'landing.products.image': 'Produktbild',
  'landing.products.ends': 'Auktion endet am {0}',
  'landing.products.ended': 'Auktion endete am {0}',
  'landing.stats.caption': 'Fakten auf einen Blick',
  'landing.stats.title': 'Unsere Erfolge',
  'landing.stats.text': 'Diese Zahlen sprechen für sich.',
  'landing.stats.auctions': 'Bieterverfahren durchgeführt',
  'landing.stats.customers': 'Zufriedene Kunden',
  'landing.stats.merchants': 'Teilnehmende Fachhändler',
  'landing.stats.bids': 'Gebote auf ein Freizeitfahrzeug',
  'landing.stats.image':
    'Ein Wohnmobil fährt auf einer Straße einen Berg hinauf.',
  'landing.faq.loading': 'Häufige Fragen werden geladen',
  'landing.faq.question': 'Frage an Fahrzeughalter',
  'landing.faq.wait_answer':
    'Sobald der Fahrzeughalter Ihre Frage beantwortet hat, können Sie eine weitere Frage stellen.',
  'landing.faq.not_allowed':
    'Fragen zum Preis und zu den Kontaktdaten des Verkäufers sind nicht zulässig.',
  'landing.faq.ask': 'Stellen Sie dem Verkäufer eine Frage',
  'landing.faq.sent': 'Ihre Frage wurde an den Verkäufer gesendet!',
  'landing.faq.advisor': 'Gebotsberater',
  'landing.faq.chance':
    'Erfahren Sie, ob Sie mit Ihrem Gebot eine realistische Chance auf den Zuschlag haben.',
  'landing.faq.high_chance': 'Hohe Chance ab',

  'pricing.title': 'Preise für die Nutzung von caravanmarkt24',
  'pricing.description':
    'Übersicht über unser einfaches und transparentes Preismodell. Für Verkäufer immer kostenlos!',
  'pricing.sellers': 'Für Verkäufer',
  'pricing.buyers': 'Für Käufer',
  'pricing.free_services': 'kostenlose Leistungen',
  'pricing.paid_services': 'kostenpflichtige Leistungen',
  'pricing.auction_creation': 'Verkaufsinserat erstellen',
  'pricing.auction_extension': 'Verkaufsinserat verlängern für neue Bieterrunde',
  'pricing.renegotiation': 'Online-Nachverhandlung',
  'pricing.vehicle': 'Fahrzeug versteigern',
  'pricing.min_price': 'Verkauf ablehnen bei Unterschreiten des Mindestverkaufspreises',
  'pricing.contract': 'Vorgefertigter, rechtssicherer Kaufvertrag',
  'pricing.assistance': 'Unterstützung bei der Inseraterstellung',
  'pricing.support': 'Telefonischer Kundensupport',
  'pricing.bidding': 'Unbegrenzte Gebotsabgabe',
  'pricing.watchlist': 'Merkliste und Suchauftrag',
  'pricing.questions': 'Online Fragen an Verkäufer stellen',
  'pricing.commission': 'Fahrzeug ersteigern (Provision)',
  'pricing.hint': 'Siehe Händlerleitfaden als registrierter Händler',

  'jobs.title': 'Aktuelle Jobangebote bei caravanmarkt24',
  'jobs.description':
    'Wir sind regelmäßig auf der Suche nach motivierten und ambitionierten Menschen für unser großartiges Team! Bewerben Sie sich bei caravanmarkt24!',
  'jobs.paragraph_1':
    'ist eine Online-Auktionsplattform für den Kauf und Verkauf von gebrauchten Wohnmobilen. Wir verfolgen die Vision, den Handel von gebrauchten Wohnmobilen zu digitalisieren und damit so einfach und komfortabel wie möglich zu machen. Die Plattform richtet sich sowohl an private Wohnmobilbesitzer, die als Verkäufer auftreten, als auch an professionelle Händler, die als Käufer auftreten.',
  'jobs.paragraph_2':
    'Werde Teil unseres Teams und unterstütze uns dabei, den Online-Wohnmobilmarkt neu zu denken und Käufer und Verkäufer von gebrauchten Wohnmobilen digital effizient zusammenzubringen.',

  'imprint.berlin': 'Berlin',
  'imprint.service': 'ist ein Service von',
  'imprint.registered': 'eingetragen im Amtsgericht',
  'imprint.directors': 'Geschäftsführer',
  'imprint.tax': 'Steuer-Nr.',
  'imprint.vat': 'USt.-ID-Nr.',
  'imprint.authors': 'Verantwortliche Personen für den Inhalt dieser Seite',
  'imprint.dispute_resolution':
    'Online-Streitbeilegung: Die Europäische Kommission stellt unter {0} eine Plattform zur Online-Streitbeilegung bereit, die Verbraucher für die Beilegung einer Streitigkeit nutzen können und auf dem Verbraucher weitere Informationen zum Thema Streitschlichtung finden können. Der Betreiber dieser Webseite ist weder dazu verpflichtet noch dazu bereit, im Falle einer Streitigkeit mit dem Nutzer an Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teilzunehmen.',

  'contacts.caption.chatbase': 'Rund um die Uhr für Sie da',
  'contacts.title.chatbase': 'Kontakt aufnehmen',
  'contacts.title.chatbase.assi': 'Service-Chat-Assistent',
  'contacts.subtitle.chatbase.assi': 'Unser intelligenter Chat-Assistent hilft Ihnen gern weiter.',
  'contacts.chatbase.assi.cta': 'Service-Chat starten',

  'contacts.caption': 'Auf allen Kanälen für Sie erreichbar',
  'contacts.title': 'Treten Sie mit uns in Kontakt',
  'contacts.text': 'Haben Sie Fragen? Wir helfen Ihnen gern weiter.',
  'contacts.chat': 'Live Chat',
  'contacts.start_chat': 'Live Chat starten',
  'contacts.meeting': 'Rückrufwunsch',
  'contacts.schedule_meeting': 'Vereinbaren Sie einen Termin',
  'contacts.error':
    'Es gab ein Problem bei der Verarbeitung Ihrer Nachricht. Bitte versuchen Sie erneut, das Formular abzusenden.',
  'contacts.success':
    'Vielen Dank für Ihre Nachricht. Ein Mitarbeiter von caravanmarkt24 wird Ihnen in Kürze zur Verfügung stehen.',

  'blog.title': 'Wohnmobil verkaufen: Ratgeber',
  'blog.description':
    'Sie möchten Ihr Wohnmobil bestmöglich verkaufen? Dann lesen Sie unsere informativen Wissensartikel mit Tipps und Tricks zum Wohnmobilverkauf.',
  'blog.show_article': 'Artikel anzeigen',
  'blog.reading_time': 'Minuten Lesezeit',
  'blog.contents': 'Inhalt',
  'blog.magazine': 'Magazin',
  'blog.view_all': 'Alle ansehen',
  'blog.recent': 'Unsere neuesten Artikel',

  'about.title':
    'Unsere Vision von einem besseren Verkaufserlebnis für Wohnmobil- und Wohnwagenbesitzer',
  'about.description':
    'Wie können wir mithilfe der Digitalisierung den Online-Verkauf von Wohnmobilen und Caravans so angenehm, sicher und zufriedenstellend wie möglich machen?',
  'about.paragraph_1':
    'Wir sind davon überzeugt, dass die Digitalisierung zunehmend alle Bereiche unseres Lebens erfasst. Und wir glauben, dass technischer Fortschritt die Dinge dauerhaft verbessert. Dazu zählt aus unserer Sicht auch der Verkauf eines gebrauchten Fahrzeugs. Daher steht hinter allem, was wir tun, eine zentrale Leitfrage:',
  'about.question':
    'Wie können wir durch digitale Werkzeuge und Prozesse den Verkauf von Wohnmobilen und Wohnwagen so einfach und komfortabel wie möglich machen?',
  'about.paragraph_2':
    'caravanmarkt24.de bietet Ihnen eine innovative Online-Lösung, die den Fahrzeugverkauf zu einer Sache der Freude und Einfachheit macht. Verkaufen Sie Ihr Wohnmobil oder Ihren Wohnwagen in kürzester Zeit zum besten Marktpreis und sparen Sie gleichzeitig Zeit und Nerven. Alles online und bequem von zuhause aus - so geht Verkaufen heute!',
  'about.founder': 'Gründer',
  'about.oleg':
    'Schon in jungen Jahren stieg Oleg in den väterlichen Gebrauchtwagenhandelsbetrieb ein und lernte das Geschäft von der Pike auf. Im Laufe der letzten Jahre hat Oleg das Geschäft übernommen, sukzessive ausgebaut und jährlich über 400 Fahrzeuge gehandelt. Seit 2019 spezialisierte er sich immer mehr auf gebrauchte Fahrzeuge aus dem Camping- und Caravansegment und verkaufte mit seinem Team Fahrzeuge an Kunden aus dem gesamten Bundesgebiet. Durch seine 10-jährige Laufbahn als Gebrauchtwagenhändler kennt er sich bestens mit den Bedürfnissen von Käufer und Verkäufer aus. Er ist Mitgründer von caravanmarkt24.de und zuständig für die operative Geschäftsentwicklung. Oleg ist studierter Betriebswirt und leidenschaftlicher Autofahrer.',
  'about.peter':
    'Seit mehr als einem Jahrzehnt ist Peter in der Berliner Start-Up-Welt zuhause. Kundenzentrierte Produktentwicklung durch innovative Cloud-Architekturen und datengetriebene Softwareentwicklung sind seine technischen Spezialgebiete. Seine berufliche Karriere begann 2009 als Machine-Learning Software-Engineer bei Nokia Maps in Berlin. Schon nach 2 Jahren folgte er dem Ruf des Marktes und machte sich als Machine-Learning Consultant selbständig, um innovative Softwareprodukte für Unternehmen wie Zalando, Zanox und eine Handvoll weiterer Berliner Start-Ups zu entwickeln. Von 2014 bis 2019 leitete Peter als CTO die Entwicklung der Online-Kunstplatform Juniqe.com. 2019 gründete er die "Peter Siemen Cloud Solution Engineering UG", um Unternehmen als freiberuflicher Cloud-Solution-Architekt zu unterstützen. Peter ist Mitgründer von caravanmarkt24.de und zuständig für die technische Produktentwicklung.',

  'faq.title': 'Häufige Fragen beim Wohnmobil- und Wohnwagenverkauf',
  'faq.description':
    'Wir geben Ihnen Antworten auf die wichtigsten Fragen, die für Sie beim Verkauf Ihres Wohnmobils oder Ihres Wohnwagens bei caravanmarkt24 von Interesse sein könnten.',

  'merchant.title': 'Sie sind Händler?',
  'merchant.description':
    'Jetzt registrieren und an regelmäßigen Auktionen teilnehmen',
  'merchant.hero.title_1': 'Exklusiver Zugang',
  'merchant.hero.title_2': 'zu gebrauchten Wohnmobilen und Wohnwagen',
  'merchant.hero.text':
    '— caravanmarkt24 ist Ihre Online-Zukaufsquelle für gebrauchte Wohnmobile und Wohnwagen! Nehmen Sie an regelmäßigen Online-Auktionen teil und ersteigern Sie interessante Fahrzeuge direkt von privat, Vermietern oder Händlerkollegen. Versteigern Sie im Gegenzug Ihre Inzahlungnahmen zum besten Händlerpreis an Aufkäufer aus ganz Deutschland.',
  'merchant.why.title': 'Ihr Mehrwert',
  'merchant.why.text':
    'Digitalisieren Sie Ihr Geschäft! Kaufen und verkaufen Sie bequem online Wohnmobile und Wohnwagen.',
  'merchant.why.purchase': 'Zukauf',
  'merchant.why.purchase.item_1': 'Modellvielfalt in Ihrem Sortiment erweitern',
  'merchant.why.purchase.item_2': 'Täglich stattfindende Online-Auktionen',
  'merchant.why.purchase.item_3': 'Fahrzeuge von privat ohne Zwischenhändler',
  'merchant.why.purchase.item_4':
    'Fahrzeuge von Händlern (Inzahlungnahmen) und aus der Vermietung',
  'merchant.why.purchase.item_5': 'Inserate mit hoher Datenqualität',
  'merchant.why.purchase.item_5.tooltip':
    'Wir bemühen uns, eine hohe Inserats- und Datenqualität zu gewährleisten. Jeder Verkäufer ist verpflichtet, uns die Zulassungsbescheinigung Teil I zu übermitteln. So können wir zum einen sicherstellen, dass der Verkäufer auch Eigentümer des Fahrzeugs ist oder bevollmächtigt für den Verkauf. Zum anderen können wir dadurch auch alle wichtigen Daten wie Fahrgestellnummer, Erstzulassung usw. prüfen. Außerdem sprechen wir persönlich mit allen Verkäufern und fordern diese auf, alle Angaben nach bestem Wissen und Gewissen zu machen und alle Mängel offenzulegen. Dem Verkäufer ist bekannt, dass Sie das Fahrzeug vor der Übernahme und Bezahlung nochmals überprüfen. Treten wider Erwarten bei der Abholung Mängel auf, von denen Sie vor der Gebotsabgabe keine Kenntnis hatten, können Sie ohne Kosten vom online geschlossenen Kaufvertrag zurücktreten. Mehr Informationen hierzu erhalten Sie in unseren AGB.',
  'merchant.why.purchase.item_6':
    'Interessante Auswahl an Wohnmobilen und Wohnwagen',
  'merchant.why.purchase.item_7': 'Provision nur bei Auktionszuschlag',
  'merchant.why.purchase.item_7.tooltip':
    'Die Vermittlungsprovision beträgt 1,75% netto auf den Zuschlagspreis. Die minimale Vergütung beträgt 399 € netto, die maximale Vergütung beträgt 3.500 € netto.',
  'merchant.why.purchase.item_8':
    'Keine Vertragsbindung, keine sonstigen Gebühren',
  'merchant.why.sell': 'Verkauf',
  'merchant.why.sell.item_1': 'Erträge im B2B-Händlerverkauf steigern',
  'merchant.why.sell.item_2': 'Verkauf zum besten Marktpreis',
  'merchant.why.sell.item_3': 'Kurze Auktionslaufzeiten',
  'merchant.why.sell.item_4': 'Hohe Vermarktungsquote',
  'merchant.why.sell.item_5':
    'Professioneller Bieterkreis mit geprüften Händlerkollegen',
  'merchant.why.sell.item_6': 'Einfache Bedienung und schnelle Eingabe',
  'merchant.why.sell.item_7': 'Schnittstelle zur Datenübertragung aus SYSCARA',
  'merchant.why.sell.item_8': 'Keine Einstellgebühr',

  'evaluate.title':
    'Wohnmobil verkaufen: Kostenlose Wertermittlung in nur 5 Min.',
  'evaluate.description':
    'Sie möchten Ihr Wohnmobil verkaufen? Dann sollten Sie besser den Wert Ihres Wohnmobils kennen. Jetzt kostenlos und unverbindlich online bewerten lassen.',

  'merchants.title': 'Händlerverzeichnis',
  'merchants.loading': 'Händler Verzeichnis wird geladen',

  'my_ads.loading': 'Meine Fahrzeuge wird geladen',

  'catalog.title': 'Wohnmobile kaufen: {0} Ergebnisse',
  'catalog.description':
    'Wohnmobil kaufen: Gebrauchte und neue Wohnmobile kaufen. Große Auswahl an günstigen Angeboten zu Wohnmobilen, Reisemobilen und Campervans.',
  'catalog.loading': 'Fahrzeuge werden geladen',
  'catalog.results': 'zu gebrauchten Wohnmobilen und Wohnwagen',
  'catalog.save_search': 'Suchauftrag speichern',
  'catalog.save_search_success': 'Suchauftrag erfolgreich angelegt',
  'catalog.save_search_success.update': 'Suchauftrag erfolgreich aktualisiert',
  'catalog.update_your_search': 'Ihren gespeicherten Suchauftrag aktualisieren',
  'catalog.update_search': 'Suchauftrag aktualisieren',
  'catalog.search_name': 'Name des Suchauftrags',
  'catalog.search.active': 'Aktiv',
  'catalog.search.inactive': 'Inaktiv',
  'catalog.search.delete.confirm': 'Wollen Sie den Suchauftrag "{0}" wirklich löschen?',
  'catalog.optimize_search':
    'Jetzt Suchauftrag anlegen und per E-Mail über passende Neuzugänge sofort informiert werden',

  'catalog.first_saved_search_notification': '<strong>Wichtiger Hinweis</strong>: Sobald Sie den ersten Suchauftrag angelegt haben, deaktiviert das System automatisch die E-Mails zu <strong>allen</strong> Neuzugängen. Das heißt, Sie erhalten dann <strong>nur</strong> noch E-Mails zu Neuzugängen auf Grundlage Ihrer Suchaufträge. Sollten Sie zu späterem Zeitpunkt doch wieder E-Mails zu <strong>allen</strong> Neuzugängen erhalten wollen, müssen Sie im Menü "Einstellungen" die Option wieder aktivieren, wodurch alle Suchaufträge automatisch deaktiviert werden.',
  'catalog.saved_searches_saved_notification': 'Ihr Suchauftrag wurde angelegt. Sie können den Suchauftrag jederzeit im Menü {0} bearbeiten',
  'catalog.saved_searches_saved_notification.update': 'Ihr Suchauftrag wurde aktualisiert. Sie können den Suchauftrag jederzeit im Menü {0} bearbeiten',
  'catalog.saved_searches': 'Suchaufträge',
  'catalog.saved_searches.new': 'Suchauftrag anlegen',
  'catalog.saved_searches.another_one': 'Weiteren Suchauftrag anlegen',
  'catalog.email': 'Neue Suchergebnisse per E-Mail erhalten',
  'catalog.search.deactivate.warning.title': 'Wichtiger Hinweis',
  'catalog.search.deactivate.warning': 'Sobald Sie die E-Mails zu Neuzugängen für alle Fahrzeuge aktivieren, werden Ihre aktiven Suchaufträge automatisch deaktiviert. Sie können nachträglich jederzeit die Suchaufträge manuell wieder aktivieren.',
  'catalog.search.activate.warning.newcomer': 'Suchauftrag aktiviert, E-Mails zu allen Neuzugängen wurden deaktiviert.',
  'catalog.search.activate.button': 'Alle E-Mails aktivieren',
  'catalog.search.error': 'Ein Fehler ist aufgetreten. Bitte versuchen Sie es erneut.',
  'catalog.saved_searches.sorting.updated_at_asc': 'älteste zuerst',
  'catalog.saved_searches.sorting.updated_at_desc': 'neueste zuerst',
  'catalog.saved_searches.sorting.name_asc': 'nach Name (A - Z)',
  'catalog.saved_searches.sorting.name_desc': 'nach Name (Z - A)',

  'catalog.vat_included': '(inkl. 19% MwSt.)',
  'catalog.min_price': 'Mindestverkaufspreis',
  'catalog.distance': 'Entfernung',
  'catalog.register':
    'Bitte registrieren Sie sich als Händler, um alle Daten einzusehen',
  'catalog.exclusive_auction': 'Exklusive Auktion',
  'catalog.your_ad': 'Ihr Inserat',
  'catalog.availability': 'Verfügbarkeit',

  'catalog.location.country.DE': 'Deutschland',
  'catalog.location.country.NL': 'Niederlande',
  'catalog.location.country.BE': 'Belgien',
  'catalog.location.country.FR': 'Frankreich',
  'catalog.location.country.IT': 'Italien',
  'catalog.location.country.AT': 'Österreich',
  'catalog.location.country.CH': 'Schweiz',
  'catalog.location.country.LU': 'Luxemburg',
  'catalog.location.country.DK': 'Dänemark',
  'catalog.location.country.CZ': 'Tschechien',
  'catalog.location.country.PL': 'Polen',
  'catalog.location.country.ES': 'Spanien',
  'catalog.location.country.HR': 'Kroatien',
  'catalog.location.country.SI': 'Slowenien',
  'catalog.location.country.SK': 'Slowakei',
  'catalog.location.country.HU': 'Ungarn',
  'catalog.location.country.SE': 'Schweden',
  'catalog.location.country.NO': 'Norwegen',
  'catalog.location.country.FI': 'Finnland',
  'catalog.location.country.PT': 'Portugal',
  'catalog.location.country.GR': 'Griechenland',

  'catalog.makes': 'Marken',
  'catalog.select_makes': 'Marken auswählen',
  'catalog.add': 'Hinzufügen',
  'catalog.enter_model': 'Modell eingeben',

  'auction.history.numberOfAuctionsInLast2Weeks': 'Auktionen in den letzten zwei Wochen',
  'auction.history.numberOfAuctionsInLast2Weeks.short': 'Anzahl Auktionsrunden:',

  'auction.history.sellerLastOnline': 'Verkäufer zuletzt online',
  'auction.history.yesterday': 'gestern',
  'auction.history.today': 'heute',
  'auction.history.x_days_ago': 'vor {0} Tagen',

  'auction.history.yesterday_at_x': 'gestern um {0}',
  'auction.history.today_at_x': 'heute um {0}',
  'auction.history.pending': 'ausstehend',
  'auction.history.x_days_ago_at_y': 'vor {0} Tagen um {1}',

  'auction.history.availabilityConfirmed': 'Fahrzeugverfügbarkeit bestätigt',
  'auction.history.availabilityConfirmed.not_yet': 'bisher nicht abgefragt',

  'auction.history.lastRejectedBid': 'Letztes abgelehntes Höchstgebot',

  'availability.banner.timer_prefix': 'noch',
  'availability.confirmation.cta': 'Verfügbarkeit bestätigen',
  // Banner on the my-ads card that asks for the availability confirmation.
  'availability.banner.title': 'Kaufinteressenten warten: Ist Ihr Fahrzeug noch verfügbar?',
  'availability.banner.text': 'Damit Kaufinteressenten weiterhin Kaufangebote für Ihr Fahrzeug abgeben können, muss die <strong>Verfügbarkeit</strong> Ihres Fahrzeugs bestätigt werden. <strong>Bitte reagieren Sie zeitnah</strong>, andernfalls beenden wir die Einholung von weiteren Angeboten.',
  'availability.banner.remaining': 'noch {0} Std.',

  'availability.confirmation.alert': 'Bestätigen bis: ',
  'availability.confirmation.step_1_of_3': 'Schritt 1 von 3: Verfügbarkeit',
  'availability.confirmation.step_2_of_3': 'Schritt 2 von 3: Preisvorstellung',
  'availability.confirmation.step_3_of_3': 'Schritt 3 von 3: Verkaufsfreigabe',

  // Site-wide modal that sends the seller to the availability check.
  'availability.modal.text': 'Für Ihr Fahrzeug steht eine Bestätigung zur Fortführung der Angebotseinholung aus. Bitte führen Sie jetzt die <strong>kurze Verfügbarkeitsabfrage</strong> durch, damit die Angebotseinholung fortgesetzt werden kann.',
  'availability.modal.cta': 'Zur Verfügbarkeitsabfrage',
  'availability.confirmation.heading': 'Verfügbarkeit bestätigen',
  'availability.confirmation.question': 'Steht Ihr Fahrzeug noch zum Verkauf?',
  'availability.confirmation.text': 'Ihr Fahrzeug befindet sich aktuell noch in der <strong>aktiven Angebotseinholung</strong>. Bitte teilen Sie uns kurz mit, ob Ihr Fahrzeug noch verfügbar ist.',
  'availability.confirmation.available': 'Fahrzeug verfügbar',
  'availability.confirmation.not_available': 'Nicht mehr verfügbar',
  'availability.confirmation.or': 'oder',
  'availability.confirmation.first_registration': 'EZ {0}',
  'availability.confirmation.mileage': '{0} km',
  'availability.confirmation.thanks.not_available': 'Vielen Dank für die Mitteilung, die Angebotseinholung zu Ihrem Fahrzeug wurde gestoppt.',

  'availability.confirmation.thanks.not_available.box': 'Sie können jederzeit <strong>kostenfrei</strong> einen <strong>neuen Verkaufsversuch</strong> starten, falls Ihr Fahrzeug wieder zum Verkauf stehen sollte.',

  'availability.confirmation.error': 'Ihre Antwort konnte nicht gespeichert werden. Bitte versuchen Sie es erneut.',

  'availability.price.title': 'Preisvorstellung senken?',
  'availability.price.title.mustReduce': 'Bitte die Preisvorstellung anpassen',
  'availability.price.text.mustReduce': 'Um das Kaufinteresse an Ihrem Fahrzeug aufrechtzuerhalten und die Verkaufschance <strong>deutlich zu erhöhen</strong>, ist eine moderate Preissenkung erforderlich.',
  'availability.price.text': 'Möchten Sie Ihren Preis anpassen, um die <strong>Verkaufschance</strong> für Ihr Fahrzeug <strong>deutlich zu erhöhen?</strong>',

  'availability.price.warning': 'Ohne eine Preisanpassung können wir die Angebotseinholung leider nicht fortführen.',
  'availability.price.currentPrice': 'Aktuelles Höchstgebot:',
  'availability.price.targetPrice': 'Aktuelle Preisvorstellung:',
  'availability.price.check': 'Preisanpassung prüfen',
  'availability.price.check.keep': 'Preis beibehalten',
  'availability.price.new_label': 'Neue Preisvorstellung in €',
  'availability.price.quick_select': 'Schnellauswahl:',
  'availability.price.submit': 'Preis jetzt senken',

  'availability.agreement.title': 'Verkaufsabsicht bestätigen',
  'availability.agreement.text': 'Kaufinteressenten geben erfahrungsgemäß gute Kaufangebote nur auf Inserate mit <strong>bestätigter Verkaufsabsicht</strong> ab. Bitte akzeptieren Sie entsprechend die nachfolgende Vereinbarung:',
  // Same agreement as ad.auction.hasSellingIntent.new.yes.infobox, without its
  // leading „Klingt fair!“ — that opener does not fit this context.
  'availability.agreement.infobox': '„Erhalte ich für mein Fahrzeug innerhalb von 24 Stunden ein Kaufangebot in Höhe von <strong>{0} oder mehr</strong>, gebe ich schon jetzt den Verkauf direkt über das Portal frei.“',
  'availability.agreement.submit': 'Weitere Angebote erhalten',

  // The chip is uppercased in CSS, so the value stays sentence case.
  'availability.success.badge': 'Verfügbarkeit bestätigt',
  'availability.success.badge_not_available': 'Angebotseinholung gestoppt',
  'availability.success.text.with_price_reduction': 'Vielen Dank, Ihre neue Preisvorstellung von <strong>{0}</strong> wurde erfolgreich für die laufende Angebotseinholung übernommen! Wir drücken Ihnen die Daumen für den Verkauf und werden Sie bei Neuigkeiten umgehend per E-Mail informieren.',
  'availability.success.text.without_price_reduction': 'Vielen Dank, Ihre bisherige Preisvorstellung von <strong>{0}</strong> wurde erfolgreich für die laufende Angebotseinholung übernommen! Wir drücken Ihnen die Daumen für den Verkauf und werden Sie bei Neuigkeiten umgehend per E-Mail informieren.',
  'auction.history.priceReductions': 'Übersicht der Preisabschläge',
  'auction.history.newPrice': 'Neue Preisvorstellung',
  'auction.history.priceUnchanged': 'Preisvorstellung seit Auktionsstart unverändert',

  'fields.name': 'Vorname',
  'fields.surname': 'Nachname',
  'fields.email': 'Email-Adresse',
  'fields.phone': 'Telefonnummer',
  'fields.question_label': 'Frage',
  'fields.question_placeholder': 'Wie können wir Ihnen helfen?',
  'fields.perimeter': 'Umkreis',
  'bis 100 km': 'bis 100 km',
  'bis 200 km': 'bis 200 km',
  'bis 300 km': 'bis 300 km',
  'ab 300 km': 'ab 300 km',

  'fields.trade_registration': 'Gewerbeanmeldung',

  'customer.data': 'Für Kunden innerhalb der Europäischen Gemeinschaft: Bitte geben Sie auf dem Registrierungsformular Ihre internationale Umsatzsteuer-Identifikationsnummer an.',

  'renegotiation.rules.button': 'Wichtig: Regeln für die Nachverhandlung',
  'renegotiation.rules.button.ok': 'OK',
  'renegotiation.your_turn': 'Sie sind am Zug',
  'renegotiation.sellers_turn': 'Verkäufer am Zug',
  'renegotiation.ends_in': 'Nachverhandlung endet in',
  'renegotiation.anr_offer_above_targetPrice.ends_in': 'Entscheidung spätestens in',

  'auth.invalid_email': 'E-Mail-Adresse ungültig',
  'auth.password': 'Passwort',
  'auth.invalid_password': 'Ungültiges Passwort',
  'auth.invalid_user_and_password': 'Falsches Passwort. Bitte noch einmal versuchen oder auf "Passwort vergessen?" klicken, um das Passwort zurückzusetzen.',
  'auth.too_many_attempts': 'Zu viele gescheiterte Login Versuche. Ihr Account wurde temporär gesperrt. Wir haben ihnen eine E-Mail mit einem Link gesendet, um ihren Account zu entsperren.',

  'auth.error_reloading': 'Ein Fehler ist aufgetreten. Bitte versuchen Sie es erneut.'
}
